import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "history",
  // base: process.env.NODE_ENV === 'production' ? '/pc' : '/pc',
  routes: [
    {
      path: "/",
      name: "teacher",
      component: () => import("@/views/teacher/layout"),
      redirect: "/index",
      children: [
        {
          path: "/index",
          name: "index",
          component: () => import("@/views/teacher/home/index")
        },
        // 课程详情页
        {
          path: "/course/detail",
          name: "HgcourseDetail",
          component: () => import("@/views/teacher/course/courseDetail")
        },
        // 课程中心页
        {
          path: "/course/center",
          name: "HgcourseCenter",
          component: () => import("@/views/teacher/course/courseCenter")
        },
        //1+X证书
        {
          path: "/xcertificate",
          name: "xcertificate",
          component: () => import("@/views/teacher/xcertificate.vue")
        },
        // 证书查询
        {
          path: "/certificate",
          name: "certificate",
          component: () => import("@/views/certificate-inquires/index.vue"),
          redirect: "/certificateQuery",
          children: [
            {
              path: "/certificateQuery",
              name: "certificateQuery",
              component: () => import("@/views/certificate-inquires/query.vue")
            },
            {
              path: "/certificateDetails",
              name: "certificateDetails",
              component: () =>
                import("@/views/certificate-inquires/details.vue")
            }
          ]
        },
        // 我的教学
        {
          path: "/teacher/index",
          name: "myTeaching",
          component: () => import("@/views/teacher/myTeaching/index.vue")
        },
        {
          path: "/teacher/index/detail",
          name: "myTeachingDetail",
          component: () => import("@/views/teacher/myTeaching/detail.vue")
        },
        // 我的教学开课详情页
        {
          path: "/teacher/myTeaching",
          name: "personageCenter",
          component: () => import("@/views/teacher/myTeaching/layout.vue"),
          redirect: "/teacher/myTeaching/courseSet/layout",
          children: [
            // 开课设置
            {
              path: "/teacher/myTeaching/courseSet/layout",
              name: "CourseSet",
              component: () =>
                import("@/views/teacher/myTeaching/courseSet/layout"),
              redirect: "/teacher/myTeaching/courseSet/cooperationAgreement",
              children: [
                // 合作协议
                {
                  path: "/teacher/myTeaching/courseSet/cooperationAgreement",
                  name: "CourseSetCooperationAgreement",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/courseSet/cooperationAgreement"
                    )
                },
                // 教学安排
                {
                  path: "/teacher/myTeaching/courseSet/teachingArrangement",
                  name: "CourseSetTeachingArrangement",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/courseSet/teachingArrangement"
                    )
                },
                // 学习设置
                {
                  path: "/teacher/myTeaching/courseSet/learningSettings",
                  name: "CourseSetLearningSettings",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/courseSet/learningSettings"
                    )
                },
                // 评分标准
                {
                  path: "/teacher/myTeaching/courseSet/certificate",
                  name: "CourseSetCertificate",
                  component: () =>
                    import("@/views/teacher/myTeaching/courseSet/certificate")
                },
                // 学生证书设置
                {
                  path: "/teacher/myTeaching/courseSet/certificateSet",
                  name: "CourseSetCertificateSet",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/courseSet/certificateSet"
                    )
                },
                // 补充信息
                {
                  path:
                    "/teacher/myTeaching/courseSet/supplementaryInformation",
                  name: "CourseSetSupplementaryInformation",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/courseSet/supplementaryInformation"
                    )
                }
              ]
            },
            // 课程建设
            {
              path: "/teacher/myTeaching/courseConstruction/layout",
              name: "Construction",
              component: () =>
                import("@/views/teacher/myTeaching/courseConstruction/layout"),
              redirect: "/teacher/myTeaching/courseConstruction/courseInfo",
              children: [
                // 课程信息
                {
                  path: "/teacher/myTeaching/courseConstruction/courseInfo",
                  name: "ConstructionCourseInfo",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/courseConstruction/courseInfo"
                    )
                },
                // 教学团队
                {
                  path: "/teacher/myTeaching/courseConstruction/teachingTeam",
                  name: "ConstructionTeachingTeam",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/courseConstruction/teachingTeam"
                    )
                },
                // 教学内容
                {
                  path:
                    "/teacher/myTeaching/courseConstruction/teachingContent",
                  name: "ConstructionTeachContent",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/courseConstruction/teachingContent/index.vue"
                    )
                },
                // 新增考试
                {
                  path:
                    "/teacher/myTeaching/courseConstruction/teachingContent/addExamination",
                  name: "ConstructionTeachContentAddExam",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/courseConstruction/teachingContent/addExamination"
                    )
                },
                // 题库
                {
                  path:
                    "/teacher/myTeaching/courseConstruction/BaseTestManagement",
                  name: "ConstructionBaseTestManagement",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/courseConstruction/BaseTestManagement"
                    )
                }
              ]
            },
            // 课程教学
            {
              path: "/teacher/myTeaching/myStudent/layout",
              name: "MyStudent",
              component: () =>
                import("@/views/teacher/myTeaching/myStudent/layout"),
              redirect: "/teacher/myTeaching/myStudent/notice",
              children: [
                // 通知公告
                {
                  path: "/teacher/myTeaching/myStudent/notice",
                  name: "MyStudentNotice",
                  component: () =>
                    import("@/views/teacher/myTeaching/myStudent/notice")
                },
                // 班级分配
                {
                  path: "/teacher/myTeaching/myStudent/classAssignment",
                  name: "MyStudentClassAssignment",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/classAssignment"
                    )
                },
                // 作业测验
                {
                  path: "/teacher/myTeaching/myStudent/homeworkTest",
                  name: "MyStudentHomeworkTest",
                  component: () =>
                    import("@/views/teacher/myTeaching/myStudent/homeworkTest")
                },
                // 考试
                {
                  path: "/teacher/myTeaching/myStudent/examination/testList",
                  name: "MyStudentTestList",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/examination/testList"
                    )
                },
                // 考试详情
                {
                  path: "/teacher/myTeaching/myStudent/examination/testDetail",
                  name: "MyStudentTestDetail",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/examination/testDetail"
                    )
                },
                // 考试预览
                {
                  path:
                    "/teacher/myTeaching/myStudent/examination/testQuestions",
                  name: "MyStudentTestQuestions",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/examination/testQuestions"
                    )
                },
                // 已批学生
                {
                  path:
                    "/teacher/myTeaching/myStudent/examination/isGroupStudent",
                  name: "MyStudentTestIsGroupStudent",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/examination/isGroupStudent"
                    )
                },
                // 未批学生
                {
                  path:
                    "/teacher/myTeaching/myStudent/examination/noBatchStudent",
                  name: "MyStudentTestNoBatchStudent",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/examination/noBatchStudent"
                    )
                },
                // 教师批阅
                {
                  path:
                    "/teacher/myTeaching/myStudent/examination/examinesStudent",
                  name: "MyStudentTestExaminesStudent",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/examination/examinesStudent"
                    )
                },
                // 教师已批详情
                {
                  path: "/teacher/myTeaching/myStudent/examination/stuAnswer",
                  name: "MyStudentTestStuAnswer",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/examination/stuAnswer"
                    )
                },
                // 未交学生
                {
                  path:
                    "/teacher/myTeaching/myStudent/examination/makingStudent",
                  name: "MyStudentTestMakingStudent",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/examination/makingStudent"
                    )
                },
                // 考试分析
                {
                  path: "/teacher/myTeaching/myStudent/examination/testAnalyse",
                  name: "MyStudentTestAnalyse",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/examination/testAnalyse"
                    )
                },
                // 讨论区
                {
                  path: "/teacher/myTeaching/myStudent/discuss/index",
                  name: "MyStudentDiscuss",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/discuss/index.vue"
                    )
                },
                // 我的学生
                {
                  path: "/teacher/myTeaching/myStudent/myStudent",
                  name: "MyStudentMyStudent",
                  component: () =>
                    import("@/views/teacher/myTeaching/myStudent/myStudent")
                },
                // 学生成绩
                {
                  path: "/teacher/myTeaching/myStudent/studentGrada/index",
                  name: "MyStudentStudentGrade",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/studentGrada/index"
                    )
                },
                // 学生成绩评定
                {
                  path:
                    "/teacher/myTeaching/myStudent/studentGrada/achievementEvaluation",
                  name: "MyStudentStudentAchievementEvaluation",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/studentGrada/achievementEvaluation"
                    )
                },
                // 学生证书列表
                {
                  path: "/teacher/myTeaching/myStudent/studentCertificateList",
                  name: "MyStudentCertificateList",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/certificateList"
                    )
                },
                // 成绩分析
                {
                  path: "/teacher/myTeaching/myStudent/achievementAnalysis",
                  name: "MyStudentStudentAnalysis",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/achievementAnalysis"
                    )
                }
              ]
            },
            // 菜单设置
            {
              path: "/teacher/myTeaching/menuSet/index",
              name: "menuSet",
              component: () =>
                import("@/views/teacher/myTeaching/menuSet/index")
            },
            // 开课统计
            {
              path: "/teacher/myTeaching/classOfStatistical/index",
              name: "classOfStatistical",
              component: () =>
                import("@/views/teacher/myTeaching/class-of-statistical/index")
            },
            // 知识图谱
            {
              path: "/teacher/myTeaching/knowledgeGraph/index",
              name: "knowledgeGraph",
              component: () =>
                import("@/views/teacher/myTeaching/knowledgeGraph/index.vue")
            }
          ]
        },
        // 学校管理
        {
          path: "/teacher/schoolManage",
          name: "schoolManage",
          component: () => import("@/views/teacher/schoolManage/layout.vue"),
          redirect: "/teacher/schoolManage/basicInfo",
          children: [
            {
              //基础信息
              path: "/teacher/schoolManage/basicInfo",
              name: "schoolManageBasicInfo",
              component: () =>
                import("@/views/teacher/schoolManage/basicInfo/index.vue"),
              redirect: "/teacher/schoolManage/basicInfo/schoolInfo",
              children: [
                //学校信息
                {
                  path: "/teacher/schoolManage/basicInfo/schoolInfo",
                  name: "schoolManageBasicSchoolInfo",
                  component: () =>
                    import(
                      "@/views/teacher/schoolManage/basicInfo/schoolInfo.vue"
                    )
                },
                //院系管理
                {
                  path: "/teacher/schoolManage/basicInfo/facultyManage",
                  name: "schoolManageBasicFacultyManage",
                  component: () =>
                    import(
                      "@/views/teacher/schoolManage/basicInfo/facultyManage.vue"
                    )
                },
                //专业管理
                {
                  path: "/teacher/schoolManage/basicInfo/majorManage",
                  name: "schoolManageBasicMajorManage",
                  component: () =>
                    import(
                      "@/views/teacher/schoolManage/basicInfo/majorManage.vue"
                    )
                },
                //班级管理
                {
                  path: "/teacher/schoolManage/basicInfo/classManage",
                  name: "schoolManageBasicClassManage",
                  component: () =>
                    import(
                      "@/views/teacher/schoolManage/basicInfo/classManage.vue"
                    )
                },
                //课程管理
                {
                  path: "/teacher/schoolManage/basicInfo/courseManage",
                  name: "schoolManageBasicCourseManage",
                  component: () =>
                    import(
                      "@/views/teacher/schoolManage/basicInfo/courseManage.vue"
                    )
                },
                //课程管理--开课设置
                {
                  path: "/teacher/schoolManage/basicInfo/startClassManageList",
                  name: "schoolManageBasicCourseManageList",
                  component: () =>
                    import(
                      "@/views/teacher/schoolManage/basicInfo/startClassManageList.vue"
                    )
                },
                //课程管理--开课设置--开课详情
                {
                  path: "/teacher/schoolManage/basicInfo/startClassManage",
                  name: "schoolManageBasicCourseManageStartClassManage",
                  component: () =>
                    import(
                      "@/views/teacher/schoolManage/basicInfo/startClassManage.vue"
                    ),
                  redirect:
                    "/teacher/schoolBasicCourseManage/startClassManage/courseInformation",
                  children: [
                    //开课信息
                    {
                      path:
                        "/teacher/schoolBasicCourseManage/startClassManage/courseInformation",
                      name:
                        "schoolManageBasicCourseManageStartClassManageCourseInformation",
                      component: () =>
                        import(
                          "@/views/teacher/schoolManage/startClassManage/courseInformation.vue"
                        )
                    },
                    //教学内容
                    {
                      path:
                        "/teacher/schoolBasicCourseManage/startClassManage/teachContent",
                      name:
                        "schoolManageBasicCourseManageStartClassManageTeachContent",
                      component: () =>
                        import(
                          "@/views/teacher/schoolManage/startClassManage/teachContent.vue"
                        )
                    },
                    //教学团队
                    {
                      path:
                        "/teacher/schoolBasicCourseManage/startClassManage/teachTeam",
                      name:
                        "schoolManageBasicCourseManageStartClassManageTeachTeam",
                      component: () =>
                        import(
                          "@/views/teacher/schoolManage/startClassManage/teachTeam.vue"
                        )
                    }
                  ]
                },
                //审核设置
                {
                  path: "/teacher/schoolManage/basicInfo/examineSetting",
                  name: "schoolManageBasicExamineSetting",
                  component: () =>
                    import(
                      "@/views/teacher/schoolManage/basicInfo/examineSetting.vue"
                    )
                }
              ]
            },
            //开课管理
            {
              path: "/teacher/schoolManage/startClassManage",
              name: "schoolManageStartClassManage",
              component: () =>
                import(
                  "@/views/teacher/schoolManage/startClassManage/index.vue"
                )
            },
            //审核
            {
              path: "/teacher/schoolManage/startClassManage/layout",
              name: "schoolManageStartClassManageLayout",
              component: () =>
                import(
                  "@/views/teacher/schoolManage/startClassManage/layout.vue"
                ),
              redirect:
                "/teacher/schoolManage/startClassManage/courseInformation",
              children: [
                //开课信息
                {
                  path:
                    "/teacher/schoolManage/startClassManage/courseInformation",
                  name: "schoolManageStartClassManageCourseInformation",
                  component: () =>
                    import(
                      "@/views/teacher/schoolManage/startClassManage/courseInformation.vue"
                    )
                },
                //教学内容
                {
                  path: "/teacher/schoolManage/startClassManage/teachContent",
                  name: "schoolManageStartClassManageTeachContent",
                  component: () =>
                    import(
                      "@/views/teacher/schoolManage/startClassManage/teachContent.vue"
                    )
                },
                //教学团队
                {
                  path: "/teacher/schoolManage/startClassManage/teachTeam",
                  name: "schoolManageStartClassManageTeachTeam",
                  component: () =>
                    import(
                      "@/views/teacher/schoolManage/startClassManage/teachTeam.vue"
                    )
                }
              ]
            },
            //教师管理
            {
              path: "/teacher/schoolManage/teacherManage",
              name: "schoolManageTeacherManage",
              component: () =>
                import("@/views/teacher/schoolManage/teacherManage.vue")
            },
            //学生管理
            {
              path: "/teacher/schoolManage/studentManage",
              name: "schoolManageStudentManage",
              component: () =>
                import("@/views/teacher/schoolManage/studentManage.vue")
            },
            //通知公告
            {
              path: "/teacher/schoolManage/notice",
              name: "schoolManageNotice",
              component: () => import("@/views/teacher/schoolManage/notice.vue")
            },
            //评论审核
            {
              path: "/teacher/comment/audit",
              name: "commentAudit",
              component: () =>
                import("@/views/teacher/schoolManage/comment/comment-audit.vue")
            }
          ]
        },
        // 课程学习
        {
          path: "/teacher/courseLearning",
          name: "courseLearning",
          component: () => import("@/views/teacher/courseLearning/layout.vue"),
          redirect: "/teacher/courseLearning/courseHome",
          children: [
            //课程首页
            {
              path: "/teacher/courseLearning/courseHome",
              name: "courseHome",
              component: () =>
                import("@/views/teacher/courseLearning/courseHome")
            },
            //课程公告
            {
              path: "/teacher/courseLearning/courseNotice",
              name: "courseNotice",
              component: () =>
                import("@/views/teacher/courseLearning/courseNotice")
            },
            //课程学习
            {
              path: "/teacher/courseLearning/courseLearn",
              name: "courseLearn",
              component: () =>
                import("@/views/teacher/courseLearning/courseLearn")
            },
            //作业测验
            {
              path: "/teacher/courseLearning/testHomework/index",
              name: "testHomeworkIndex",
              component: () =>
                import("@/views/teacher/courseLearning/testHomework/index.vue"),
              redirect: "/teacher/courseLearning/testHomework/whole",
              children: [
                // 全部
                {
                  path: "/teacher/courseLearning/testHomework/whole",
                  name: "courseLearningTestHomeworkWhole",
                  component: () =>
                    import(
                      "@/views/teacher/courseLearning/testHomework/whole.vue"
                    )
                },
                // 作业
                {
                  path: "/teacher/courseLearning/testHomework/homework",
                  name: "courseLearningTestHomeworkHomework",
                  component: () =>
                    import(
                      "@/views/teacher/courseLearning/testHomework/homework.vue"
                    )
                },
                // 测验
                {
                  path: "/teacher/courseLearning/testHomework/test",
                  name: "courseLearningTestHomeworkTest",
                  component: () =>
                    import(
                      "@/views/teacher/courseLearning/testHomework/test.vue"
                    )
                }
              ]
            },
            //阶段考试
            {
              path: "/teacher/courseLearning/test/index",
              name: "testIndex",
              component: () =>
                import("@/views/teacher/courseLearning/test/index.vue")
            },
            //讨论区
            {
              path: "/teacher/courseLearning/discuss/index",
              name: "discussIndex",
              component: () =>
                import("@/views/teacher/courseLearning/discuss/index.vue"),
              redirect: "/teacher/courseLearning/discuss/wholeDiscuss",
              children: [
                // 全部讨论
                {
                  path: "/teacher/courseLearning/discuss/wholeDiscuss",
                  name: "courseLearningDiscussWholeDiscuss",
                  component: () =>
                    import(
                      "@/views/teacher/courseLearning/discuss/wholeDiscuss.vue"
                    )
                },
                // 老师答疑
                {
                  path: "/teacher/courseLearning/discuss/teachAnswer",
                  name: "courseLearningDiscussTeachAnswer",
                  component: () =>
                    import(
                      "@/views/teacher/courseLearning/discuss/teachAnswer.vue"
                    )
                },
                // 课堂交流
                {
                  path: "/teacher/courseLearning/discuss/classCommunication",
                  name: "courseLearningDiscussClassCommunication",
                  component: () =>
                    import(
                      "@/views/teacher/courseLearning/discuss/classCommunication.vue"
                    )
                },
                // 综合讨论
                {
                  path: "/teacher/courseLearning/discuss/comprehensiveDisscuss",
                  name: "courseLearningDiscussComprehensiveDiscuss",
                  component: () =>
                    import(
                      "@/views/teacher/courseLearning/discuss/comprehensiveDisscuss.vue"
                    )
                }
              ]
            },
            //评分标准
            {
              path: "/teacher/courseLearning/scoringCriteria/index",
              name: "scoringCriteriaIndex",
              component: () =>
                import(
                  "@/views/teacher/courseLearning/scoringCriteria/index.vue"
                )
            },
            //课程评价
            {
              path: "/teacher/courseLearning/courseEvaluate",
              name: "courseEvaluate",
              component: () =>
                import("@/views/teacher/courseLearning/courseEvaluate.vue")
            }
          ]
        },
        // 项目管理
        {
          path: "/project/index",
          name: "projectIndex",
          component: () => import("@/views/project/index")
        },
        // 项目管理
        {
          path: "/project/myProject",
          name: "myProject",
          component: () => import("@/views/project/myProject"),
          children: [
            //专业基础信息
            {
              path: "/project/major",
              name: "major",
              component: () => import("@/views/project/major.vue")
            },
            //栏目管理
            {
              path: "/project/column",
              name: "column",
              component: () => import("@/views/project/column.vue")
              // children: [
              //   {
              //     path: "/project/column/:id",
              //     name: "column",
              //     component: () => import("@/views/project/column/index.vue"),
              //   },
              // ],
            },
            //教师管理
            {
              path: "/project/teacher",
              name: "teacher",
              component: () => import("@/views/project/teacher.vue")
            },
            //课程
            {
              path: "/project/curriculum",
              name: "curriculum",
              component: () => import("@/views/project/material.vue")
            },
            //资源
            {
              path: "/project/resource",
              name: "resource",
              component: () => import("@/views/project/material.vue")
            },
            //添加资源
            {
              path: "/project/UploadSource",
              name: "ConstructionUploadSource",
              component: () => import("@/views/project/UploadSource")
            },
            //素材
            {
              path: "/project/material",
              name: "material",
              component: () => import("@/views/project/material.vue")
            },
            //资源审核
            {
              path: "/project/resourceAudit",
              name: "resourceAudit",
              component: () => import("@/views/project/resourceAudit.vue")
            },
            //评论审核
            {
              path: "/project/commentAudit",
              name: "procommentAudit",
              component: () => import("@/views/project/commentAudit.vue")
            },
            {
              path: "/project/resourceDetail",
              name: "schoolManageResourceDetail",
              component: () => import("@/views/project/resourceDetail.vue")
            },
            //友情链接
            {
              path: "/project/friendlink",
              name: "friendLink",
              component: () => import("@/views/project/friendlink.vue")
            }
          ]
        },
        // 个人中心
        {
          path: "/teacher/personalCenter",
          name: "personalCenter",
          component: () => import("@/views/teacher/personalCenter/layout.vue"),
          redirect: "/teacher/personalCenter/personalData",
          children: [
            //个人资料
            {
              path: "/teacher/personalCenter/personalData",
              name: "personalCenterPersonalData",
              component: () =>
                import("@/views/teacher/personalCenter/personalData.vue")
            },
            //修改密码
            {
              path: "/teacher/personalCenter/changePassword",
              name: "personalCenterChangePassword",
              component: () =>
                import("@/views/teacher/personalCenter/changePassword.vue")
            },
            //关联账号
            {
              path: "/teacher/personalCenter/associatedAccount",
              name: "personalCenterAssociatedAccount",
              component: () =>
                import("@/views/teacher/personalCenter/associatedAccount.vue")
            },
            //用户认证
            {
              path: "/teacher/personalCenter/certificationManage",
              name: "personalCenterCertificationManage",
              component: () =>
                import("@/views/teacher/personalCenter/certificationManage.vue")
            },
            //新闻公告
            {
              path: "/teacher/personalCenter/notice",
              name: "personalCenterNotice",
              component: () =>
                import("@/views/teacher/personalCenter/notice.vue")
            },
            //我的消息
            {
              path: "/teacher/personalCenter/message",
              name: "personalCenterMessage",
              component: () =>
                import("@/views/teacher/personalCenter/message.vue")
            }
          ]
        },
        // 我的学习
        {
          path: "/teacher/myStudy",
          name: "myStudy",
          component: () => import("@/views/teacher/myStudy/layout.vue"),
          redirect: "/teacher/myStudy/myCourse",
          children: [
            // 我的课程
            {
              path: "/teacher/myStudy/myCourse",
              name: "myCourse",
              component: () =>
                import("@/views/teacher/myStudy/myCourse/index.vue")
            },
            // 讨论区
            {
              path: "/teacher/myStudy/discussArea",
              name: "discussArea",
              component: () =>
                import("@/views/teacher/myStudy/discussArea/index.vue")
            },
            // 我的证书
            {
              path: "/teacher/myStudy/myCertificate",
              name: "myCertificate",
              component: () =>
                import("@/views/teacher/myStudy/myCertificate/index.vue")
            }
          ]
        }
      ]
    },
    // 登录
    {
      path: "/login/:type",
      name: "login",
      component: () => import("@/views/login/index")
    },
    //回首页
    {
      path: "/supplierAllBack",
      name: "SupplierAllBack",
      component: () => import("@/views/components/supplierAllBack.vue")
    },
    //回课程详情页
    {
      path: "/goCourseDetailBack",
      name: "goCourseDetailBack",
      component: () => import("@/views/components/goCourseDetailBack.vue")
    },
    //回课程中心页
    {
      path: "/goCourseCenterBack",
      name: "goCourseCenterlBack",
      component: () => import("@/views/components/goCourseCenterBack.vue")
    },
    //回课程学习页
    {
      path: "/goCourseLearn",
      name: "goCourseLearn",
      component: () => import("@/views/components/goCourseLearn.vue")
    },
    //考试未完成--去考试
    {
      path: "/socketA",
      name: "socketA",
      component: () => import("@/views/components/basedata/socketA.vue")
    },
    //考试完成--详情页
    {
      path: "/socketB",
      name: "socketB",
      component: () => import("@/views/components/basedata/socketB.vue")
    },
    // 微信分享
    {
      path: "/WeChatShare",
      name: "WeChatShare",
      component: () => import("@/components/WeChatShare")
    },
    // 新课程学习页面
    {
      path: "/newCourseLearn",
      name: "newCourseLearn",
      component: () => import("@/views/new-course-learn/index.vue")
    },
    // 新课程学习页面 => 2版
    {
      path: "/newCourseLearns",
      name: "newCourseLearns",
      component: () => import("@/views/new-course-learn/learn.vue")
    },
    // 专业模板一
    {
      path: "/templateOne",
      name: "templateOne",
      component: () => import("@/views/custom/templateOne/layout.vue"),
      redirect: "/templateOne/index",
      children: [
        //专业首页
        {
          path: "/templateOne/index",
          name: "templateOneIndex",
          component: () => import("@/views/custom/templateOne/index.vue")
        },
        //课程中心
        {
          path: "/templateOne/courseCenter",
          name: "templateOneCourseCenter",
          component: () => import("@/views/custom/templateOne/courseCenter.vue")
        },
        //课程详情
        {
          path: "/templateOne/courseDetail",
          name: "templateOneCourseDetail",
          component: () => import("@/views/custom/templateOne/courseDetail.vue")
        },
        //资源中心
        {
          path: "/templateOne/resourceCenter",
          name: "templateOneResourceCenter",
          component: () =>
            import("@/views/custom/templateOne/resourceCenter.vue")
        },
        //资源详情
        {
          path: "/templateOne/resourceDetail",
          name: "templateOneResourceDetail",
          component: () =>
            import("@/views/custom/templateOne/resourceDetail.vue")
        },
        //专业介绍
        {
          path: "/templateOne/majorInstruction",
          name: "templateOneMajorInstruction",
          component: () =>
            import("@/views/custom/templateOne/majorInstruction.vue")
        },
        //有左侧二级图文列表
        {
          path: "/templateOne/imageList",
          name: "templateOneImageList",
          component: () => import("@/views/custom/templateOne/imageList.vue")
        },
        //无左侧二级图文列表
        {
          path: "/templateOne/noSecondImageList",
          name: "templateOneNoSecondImageList",
          component: () =>
            import("@/views/custom/templateOne/noSecondImageList.vue")
        },
        //详情页
        {
          path: "/templateOne/detail",
          name: "templateOneDetail",
          component: () => import("@/views/custom/templateOne/detail.vue")
        },
        //文字列表
        {
          path: "/templateOne/textList",
          name: "templateOneTextList",
          component: () => import("@/views/custom/templateOne/textList.vue")
        },
        //图文页
        {
          path: "/templateOne/imageText",
          name: "templateOneImageText",
          component: () => import("@/views/custom/templateOne/imageText.vue")
        }
      ]
    },
    //课程自定义---图像图形设计
    {
      path: "/customizeCourse",
      name: "customizeCourse",
      component: () => import("@/views/customizeCourse/layout.vue"),
      redirect: "/customizeCourse/courseHome",
      children: [
        //课程首页
        {
          path: "/customizeCourse/courseHome",
          name: "customizeCourseCourseHome",
          component: () => import("@/views/customizeCourse/courseHome.vue")
        },
        //课程学习
        {
          path: "/customizeCourse/courseLearn",
          name: "customizeCourseCourseLearn",
          component: () => import("@/views/customizeCourse/courseLearn.vue")
        },
        //课程概况
        {
          path: "/customizeCourse/courseDetails",
          name: "customizeCourseCourseDetails",
          component: () => import("@/views/customizeCourse/courseDetails.vue")
        },
        //企业案例
        {
          path: "/customizeCourse/courseStandard",
          name: "customizeCourseCourseStandard",
          component: () => import("@/views/customizeCourse/courseStandard.vue")
        }
      ]
    },
    //课程自定义---徐特立高级职业中学---视频设计与制作
    {
      path: "/custom/Xtl_VideoDesign",
      name: "XtlVideoDesign",
      component: () => import("@/views/custom/Xtl_VideoDesign/layout.vue"),
      redirect: "/custom/Xtl_VideoDesign/home",
      children: [
        //课程首页
        {
          path: "/custom/Xtl_VideoDesign/home",
          name: "XtlVideoDesignCourseHome",
          component: () =>
            import("@/views/custom/Xtl_VideoDesign/courseHome.vue")
        },
        //课程学习
        {
          path: "/custom/Xtl_VideoDesign/learn",
          name: "XtlVideoDesignCourseLearn",
          component: () =>
            import("@/views/custom/Xtl_VideoDesign/courseLearn.vue")
        },
        //课程概况
        {
          path: "/custom/Xtl_VideoDesign/courseDetails",
          name: "XtlVideoDesignCourseDetails",
          component: () =>
            import("@/views/custom/Xtl_VideoDesign/courseDetails.vue")
        },
        //企业案例
        {
          path: "/custom/Xtl_VideoDesign/standard",
          name: "XtlVideoDesignCourseStandard",
          component: () =>
            import("@/views/custom/Xtl_VideoDesign/courseStandard.vue")
        }
      ]
    },
    //课程自定义---视频设计与制作
    {
      path: "/videoDesign",
      name: "videoDesign",
      component: () => import("@/views/videoDesign/layout.vue"),
      redirect: "/videoDesign/videoHome",
      children: [
        //课程首页
        {
          path: "/videoDesign/videoHome",
          name: "videoDesignVideoHome",
          component: () => import("@/views/videoDesign/videoHome.vue")
        },
        //课程学习
        {
          path: "/videoDesign/videoCourseLearn",
          name: "videoDesignVideoCourseLearn",
          component: () => import("@/views/videoDesign/videoCourseLearn.vue")
        },
        //课程概况
        {
          path: "/videoDesign/videoCourseDetails",
          name: "videoDesignVideoCourseDetails",
          component: () => import("@/views/videoDesign/videoCourseDetails.vue")
        },
        //企业案例
        {
          path: "/videoDesign/videoCourseStandard",
          name: "videoDesignVideoCourseStandard",
          component: () => import("@/views/videoDesign/videoCourseStandard.vue")
        }
      ]
    },
    //课程自定义---会计信息化
    {
      path: "/accountInformation",
      name: "accountInformation",
      component: () => import("@/views/accountInformation/layout.vue"),
      redirect: "/accountInformation/accountHome",
      children: [
        //课程首页
        {
          path: "/accountInformation/accountHome",
          name: "accountInformationAccountHome",
          component: () => import("@/views/accountInformation/accountHome.vue")
        },
        //课程学习
        {
          path: "/accountInformation/accountCourseLearn",
          name: "accountInformationAccountCourseLearn",
          component: () =>
            import("@/views/accountInformation/accountCourseLearn.vue")
        },
        //课程概况
        {
          path: "/accountInformation/accountCourseDetails",
          name: "accountInformationAccountCourseDetails",
          component: () =>
            import("@/views/accountInformation/accountCourseDetails.vue")
        },
        //企业案例
        {
          path: "/accountInformation/accountCourseStandard",
          name: "accountInformationAccountCourseStandard",
          component: () =>
            import("@/views/accountInformation/accountCourseStandard.vue")
        }
      ]
    },

    // //课程自定义---网络设备安装与调试
    {
      path: "/networkEquipment",
      name: "networkEquipment",
      component: () => import("@/views/networkEquipment/layout.vue"),
      redirect: "/networkEquipment/networkHome",
      children: [
        //课程首页
        {
          path: "/networkEquipment/networkHome",
          name: "networkEquipmentNetworkHome",
          component: () => import("@/views/networkEquipment/networkHome.vue")
        },
        //课程学习
        {
          path: "/networkEquipment/networkCourseLearn",
          name: "networkEquipmentNetworkCourseLearn",
          component: () =>
            import("@/views/networkEquipment/networkCourseLearn.vue")
        },
        //企业案例
        {
          path: "/networkEquipment/networkCourseStandard",
          name: "networkEquipmentNetworkCourseStandard",
          component: () =>
            import("@/views/networkEquipment/networkCourseStandard.vue")
        }
      ]
    },
    //课程自定义---语文
    {
      path: "/language",
      name: "language",
      component: () => import("@/views/language/layout.vue"),
      redirect: "/language/languageHome",
      children: [
        //课程首页
        {
          path: "/language/languageHome",
          name: "languageLanguageHome",
          component: () => import("@/views/language/languageHome.vue")
        },
        //课程学习
        {
          path: "/language/languageCourseLearn",
          name: "languageLanguageCourseLearn",
          component: () => import("@/views/language/languageCourseLearn.vue")
        },
        //企业案例
        {
          path: "/language/languageCourseStandard",
          name: "languageLanguageCourseStandard",
          component: () => import("@/views/language/languageCourseStandard.vue")
        }
      ]
    },
    //课程自定义---基础会计
    {
      path: "/basicAccountancy",
      name: "basicAccountancy",
      component: () => import("@/views/basic-accountancy/layout.vue"),
      redirect: "/basicAccountancy/index",
      children: [
        //课程首页
        {
          path: "/basicAccountancy/index",
          name: "basicAccountancyIndex",
          component: () => import("@/views/basic-accountancy/index.vue")
        },
        //课程标准
        {
          path: "/basicAccountancy/standardList",
          name: "basicAccountancyStandardList",
          component: () => import("@/views/basic-accountancy/standard-list.vue")
        },
        //课程学习
        {
          path: "/basicAccountancy/courseLearn",
          name: "basicAccountancyCourseLearn",
          component: () => import("@/views/basic-accountancy/course-learn.vue")
        },
        //课程介绍
        {
          path: "/basicAccountancy/list",
          name: "basicAccountancyList",
          component: () => import("@/views/basic-accountancy/list.vue")
        },
        //课程成效
        {
          path: "/basicAccountancy/effect",
          name: "basicAccountancyEffect",
          component: () => import("@/views/basic-accountancy/effect.vue")
        },
        //课程团队
        {
          path: "/basicAccountancy/team",
          name: "basicAccountancyTeam",
          component: () => import("@/views/basic-accountancy/team.vue")
        },
        //配套教材
        {
          path: "/basicAccountancy/material",
          name: "basicAccountancyMaterial",
          component: () => import("@/views/basic-accountancy/material.vue")
        },
        //结业证书 course-completion certificate
        {
          path: "/basicAccountancy/certificate",
          name: "basicAccountancyCertificate",
          component: () => import("@/views/basic-accountancy/certificate.vue")
        },
        //课程img-List  实训环境
        {
          path: "/basicAccountancy/imgList",
          name: "basicAccountancyImgList",
          component: () => import("@/views/basic-accountancy/img-list.vue")
        },
        //详情页
        {
          path: "/basicAccountancy/content",
          name: "basicAccountancyContent",
          component: () => import("@/views/basic-accountancy/content.vue")
        },
        // 实训环境
        {
          path: "/basicAccountancy/environment",
          name: "basicAccountancyEnvironment",
          component: () => import("@/views/basic-accountancy/environment.vue")
        }
      ]
    },
    //课程自定义---图形图像处理
    {
      path: "/imageProcess",
      name: "imageProcess",
      component: () => import("@/views/custom/imageProcess/layout.vue"),
      redirect: "/imageProcess/imageHome",
      children: [
        // 课程首页
        {
          path: "/imageProcess/imageHome",
          name: "imageProcessImageHome",
          component: () => import("@/views/custom/imageProcess/imageHome.vue")
        },
        //课程学习
        {
          path: "/imageProcess/imageCourseLearn",
          name: "imageProcessImageCourseLearn",
          component: () =>
            import("@/views/custom/imageProcess/imageCourseLearn.vue")
        },
        //企业案例
        {
          path: "/imageProcess/imageCourseStandard",
          name: "imageProcessImageCourseStandard",
          component: () =>
            import("@/views/custom/imageProcess/imageCourseStandard.vue")
        }
      ]
    },
    //课程自定义---素描
    {
      path: "/sketch",
      name: "sketch",
      component: () => import("@/views/custom/sketch/layout.vue"),
      redirect: "/sketch/sketchHome",
      children: [
        //课程首页
        {
          path: "/sketch/sketchHome",
          name: "sketchSketchHome",
          component: () => import("@/views/custom/sketch/sketchHome.vue")
        }
      ]
    },
    // 证书二维码扫码跳转的页面
    {
      path: "/certificateQRCode",
      name: "certificateQRCode",
      component: () => import("@/views/certificate-inquires/QR-code.vue")
    },
    // 课程自定义---幼儿语言教育与活动指导
    {
      path: "/childEdu",
      name: "childEdu",
      component: () => import("@/views/child-edu/layout.vue"),
      redirect: "/child-edu/home",
      children: [
        //课程首页
        {
          path: "/child-edu/home",
          name: "childEduHome",
          component: () => import("@/views/child-edu/home.vue")
        },
        //课程学习
        {
          path: "/child-edu/learn",
          name: "childEduLearn",
          component: () => import("@/views/child-edu/learn.vue")
        },
        //企业案例
        {
          path: "/child-edu/standard",
          name: "childEduStandard",
          component: () => import("@/views/child-edu/standard.vue")
        }
      ]
    },
    // 课程自定义---中国特色社会主义
    {
      path: "/CN-features",
      name: "CNFeatures",
      component: () => import("@/views/CN-features/layout.vue"),
      redirect: "/CN-features/home",
      children: [
        //课程首页
        {
          path: "/CN-features/home",
          name: "CNFeaturesHome",
          component: () => import("@/views/CN-features/home.vue")
        },
        //课程学习
        {
          path: "/CN-features/learn",
          name: "CNFeaturesLearn",
          component: () => import("@/views/CN-features/learn.vue")
        },
        //企业案例
        {
          path: "/CN-features/standard",
          name: "CNFeaturestandard",
          component: () => import("@/views/CN-features/standard.vue")
        },
        //文字列表
        {
          path: "/CN-features/list",
          name: "CNFeatureList",
          component: () => import("@/views/CN-features/list.vue")
        },
        //其他教师列表
        {
          path: "/CN-features/teacherList",
          name: "CNFeatureTeacherList",
          component: () => import("@/views/CN-features/teacherList.vue")
        },
        //其他教师详情
        {
          path: "/CN-features/teacherDetail",
          name: "CNFeatureTeacherDetail",
          component: () => import("@/views/CN-features/teacherDetail.vue")
        }
      ]
    },
    // 课程自定义---心里健康
    {
      path: "/mental-health",
      name: "mentalHealth",
      component: () => import("@/views/mental-health/layout.vue"),
      redirect: "/mental-health/home",
      children: [
        //课程首页
        {
          path: "/mental-health/home",
          name: "mentalHealthHome",
          component: () => import("@/views/mental-health/home.vue")
        },
        //课程学习
        {
          path: "/mental-health/learn",
          name: "mentalHealthLearn",
          component: () => import("@/views/mental-health/learn.vue")
        },
        //其他页
        {
          path: "/mental-health/standard",
          name: "mentalHealthstandard",
          component: () => import("@/views/mental-health/standard.vue")
        }
      ]
    },
    // 课程自定义--平乡职教中心--中国特色社会主义
    {
      path: "/custom/Px_Chsocialism",
      name: "PXChsocialism",
      component: () => import("@/views/custom/Px_Chsocialism/layout.vue"),
      redirect: "/custom/Px_Chsocialism/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "PXChsocialismHome",
          component: () => import("@/views/custom/Px_Chsocialism/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "PXChsocialismLearn",
          component: () => import("@/views/custom/Px_Chsocialism/learn.vue")
        },
        //企业案例
        {
          path: "standard",
          name: "PXChsocialismstandard",
          component: () => import("@/views/custom/Px_Chsocialism/standard.vue")
        }
      ]
    },
    // 课程自定义--平乡职教中心--心理健康
    {
      path: "/custom/Px_Mentalhealth",
      name: "PxMentalhealth",
      component: () => import("@/views/custom/Px_Mentalhealth/layout.vue"),
      redirect: "/custom/Px_Mentalhealth/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "PxMentalhealthHome",
          component: () => import("@/views/custom/Px_Mentalhealth/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "PxMentalhealthLearn",
          component: () => import("@/views/custom/Px_Mentalhealth/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "PxMentalhealthstandard",
          component: () => import("@/views/custom/Px_Mentalhealth/standard.vue")
        }
      ]
    },

    // 课程自定义--长治卫生学校--中国特色社会主义
    {
      path: "/custom/Czwx_Chsocialism",
      name: "CzwxChsocialism",
      component: () => import("@/views/custom/Czwx_Chsocialism/layout.vue"),
      redirect: "/custom/Czwx_Chsocialism/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "CzwxChsocialismHome",
          component: () => import("@/views/custom/Czwx_Chsocialism/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "CzwxChsocialismLearn",
          component: () => import("@/views/custom/Czwx_Chsocialism/learn.vue")
        },
        //企业案例
        {
          path: "standard",
          name: "CzwxChsocialismstandard",
          component: () =>
            import("@/views/custom/Czwx_Chsocialism/standard.vue")
        }
      ]
    },
    // 课程自定义--长治卫生学校--心理健康
    {
      path: "/custom/Czwx_Mentalhealth",
      name: "CzwxMentalhealth",
      component: () => import("@/views/custom/Czwx_Mentalhealth/layout.vue"),
      redirect: "/custom/Czwx_Mentalhealth/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "CzwxMentalhealthHome",
          component: () => import("@/views/custom/Czwx_Mentalhealth/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "CzwxMentalhealthLearn",
          component: () => import("@/views/custom/Px_Mentalhealth/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "CzwxMentalhealthstandard",
          component: () =>
            import("@/views/custom/Czwx_Mentalhealth/standard.vue")
        }
      ]
    },
    // 课程自定义--长治卫生学校--职业道德和法制
    {
      path: "/custom/Czwx_Morality",
      name: "CzwxMorality",
      component: () => import("@/views/custom/Czwx_Morality/layout.vue"),
      redirect: "/custom/Czwx_Morality/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "CzwxMoralityHome",
          component: () => import("@/views/custom/Czwx_Morality/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "CzwxMoralityLearn",
          component: () => import("@/views/custom/Czwx_Morality/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "CzwxMoralitystandard",
          component: () => import("@/views/custom/Czwx_Morality/standard.vue")
        }
      ]
    },
    // 课程自定义--长治卫生学校--哲学人生
    {
      path: "/custom/Czwx_Philosophy",
      name: "CzwxPhilosophy",
      component: () => import("@/views/custom/Czwx_Philosophy/layout.vue"),
      redirect: "/custom/Czwx_Philosophy/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "CzwxPhilosophyHome",
          component: () => import("@/views/custom/Czwx_Philosophy/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "CzwxPhilosophyLearn",
          component: () => import("@/views/custom/Czwx_Philosophy/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "CzwxPhilosophystandard",
          component: () => import("@/views/custom/Czwx_Philosophy/standard.vue")
        }
      ]
    },
    // 课程自定义--山西铁道职业技术学院--机车制动系统
    {
      path: "/custom/Tdzy_Lobraking",
      name: "TdzyLobraking",
      component: () => import("@/views/custom/Tdzy_Lobraking/layout.vue"),
      redirect: "/custom/Tdzy_Lobraking/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TdzyLobrakingHome",
          component: () => import("@/views/custom/Tdzy_Lobraking/Home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TdzyLobrakingLearn",
          component: () => import("@/views/custom/Tdzy_Lobraking/Learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "TdzyLobrakingstandard",
          component: () => import("@/views/custom/Tdzy_Lobraking/Standard.vue")
        }
      ]
    },
    // 课程自定义--山西铁道职业技术学院--机车总体及走行部 电力机车
    {
      path: "/custom/Tdzy_Electric",
      name: "TdzyElectric",
      component: () => import("@/views/custom/Tdzy_Electric/layout.vue"),
      redirect: "/custom/Tdzy_Electric/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TdzyElectricHome",
          component: () => import("@/views/custom/Tdzy_Electric/Home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TdzyElectricLearn",
          component: () => import("@/views/custom/Tdzy_Electric/Learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "TdzyElectricStandard",
          component: () => import("@/views/custom/Tdzy_Electric/Standard.vue")
        }
      ]
    },
    // 课程自定义--太原卫生学院--解剖学基础
    {
      path: "/custom/Tywx_dissection",
      name: "TywxDissection",
      component: () => import("@/views/custom/Tywx_dissection/layout.vue"),
      redirect: "/custom/Tywx_dissection/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TywxDissectionHome",
          component: () => import("@/views/custom/Tywx_dissection/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TywxDissectionLearn",
          component: () => import("@/views/custom/Tywx_dissection/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "TywxDissectionStandard",
          component: () => import("@/views/custom/Tywx_dissection/standard.vue")
        },
        //实训环境
        {
          path: "training",
          name: "TywxDissectionTraining",
          component: () => import("@/views/custom/Tywx_dissection/training.vue")
        },
        //实训环境
        {
          path: "courseDetails",
          name: "TywxDissectionDetails",
          component: () =>
            import("@/views/custom/Tywx_dissection/courseDetails.vue")
        }
      ]
    },
    // 课程自定义--太原师范学院--现代教育技术
    {
      path: "/custom/Tysf_Education",
      name: "TysfEducation",
      component: () => import("@/views/custom/Tysf_Education/layout.vue"),
      redirect: "/custom/Tysf_Education/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TysfEducationHome",
          component: () => import("@/views/custom/Tysf_Education/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TysfEducationLearn",
          component: () => import("@/views/custom/Tysf_Education/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "TysfEducationStandard",
          component: () => import("@/views/custom/Tysf_Education/standard.vue")
        },
        // 内容详情
        {
          path: "detail",
          name: "TysfEducationDetail",
          component: () =>
            import("@/views/custom/Tysf_Education/contentDetails.vue")
        },
        //课程详情
        {
          path: "courseDetail",
          name: "TysfEducationCourseDetail",
          component: () =>
            import("@/views/custom/Tysf_Education/courseDetails.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "TysfEducationTeachingTeam",
          component: () =>
            import("@/views/custom/Tysf_Education/teachingTeam.vue")
        },
        //教学团队详情
        {
          path: "teacherDetail",
          name: "TysfEducationTeacherDetail",
          component: () =>
            import("@/views/custom/Tysf_Education/teacherDetail.vue")
        },
        //教辅资料
        {
          path: "teachingMaterials",
          name: "TysfEducationTeachingMaterials",
          component: () =>
            import("@/views/custom/Tysf_Education/teachingMaterials.vue")
        },
        //课程介绍
        {
          path: "courseIntroduce",
          name: "TysfEducationCourseIntroduce",
          component: () =>
            import("@/views/custom/Tysf_Education/courseIntroduce.vue")
        }
        // //实训环境
        // {
        //   path: "training",
        //   name: "TywxDissectionTraining",
        //   component: () => import("@/views/custom/Tywx_dissection/training.vue")
        // },
      ]
    },
    // 课程自定义--果洛州职业技术学院-酒店餐饮服务与管理
    {
      path: "/custom/Glz_Hotelcatering",
      name: "GlzHotelcatering",
      component: () => import("@/views/custom/Glz_Hotelcatering/layout.vue"),
      redirect: "/custom/Glz_Hotelcatering/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "GlzHotelcateringHome",
          component: () => import("@/views/custom/Glz_Hotelcatering/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "GlzHotelcateringLearn",
          component: () => import("@/views/custom/Glz_Hotelcatering/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "GlzHotelcateringStandard",
          component: () =>
            import("@/views/custom/Glz_Hotelcatering/standard.vue")
        }
      ]
    },
    // 课程自定义--果洛州职业技术学院-服务礼仪
    {
      path: "/custom/Glz_ServiceEtiquette",
      name: "GlzServiceEtiquette",
      component: () => import("@/views/custom/Glz_ServiceEtiquette/layout.vue"),
      redirect: "/custom/Glz_ServiceEtiquette/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "GlzServiceEtiquetteHome",
          component: () =>
            import("@/views/custom/Glz_ServiceEtiquette/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "GlzServiceEtiquetteLearn",
          component: () =>
            import("@/views/custom/Glz_ServiceEtiquette/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "GlzServiceEtiquetteStandard",
          component: () =>
            import("@/views/custom/Glz_ServiceEtiquette/standard.vue")
        },
        //实训环境
        {
          path: "trainingEnvironment",
          name: "GlzServiceEtiquetteTrainingEnvironment",
          component: () =>
            import(
              "@/views/custom/Glz_ServiceEtiquette/trainingEnvironment.vue"
            )
        },
        //教学团队
        {
          path: "courseStandard",
          name: "GlzServiceEtiquetteCourseStandard",
          component: () =>
            import("@/views/custom/Glz_ServiceEtiquette/courseStandard.vue")
        }
      ]
    },
    // 课程自定义--科尔沁右翼中旗中等职业学校--无人机概述
    {
      path: "/custom/Keq_UnmannedAerialVehicle",
      name: "KeqUnmannedAerialVehicle",
      component: () =>
        import("@/views/custom/Keq_UnmannedAerialVehicle/layout.vue"),
      redirect: "/custom/Keq_UnmannedAerialVehicle/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "KeqUnmannedAerialVehicleHome",
          component: () =>
            import("@/views/custom/Keq_UnmannedAerialVehicle/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "KeqUnmannedAerialVehicleLearn",
          component: () =>
            import("@/views/custom/Keq_UnmannedAerialVehicle/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "KeqUnmannedAerialVehicleCourseGeneralize",
          component: () =>
            import(
              "@/views/custom/Keq_UnmannedAerialVehicle/courseGeneralize.vue"
            )
        },
        //其他页
        {
          path: "standard",
          name: "KeqUnmannedAerialVehicleStandard",
          component: () =>
            import("@/views/custom/Keq_UnmannedAerialVehicle/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "KeqUnmannedAerialVehicleTeachingTeam",
          component: () =>
            import("@/views/custom/Keq_UnmannedAerialVehicle/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "KeqUnmannedAerialVehicleActivityList",
          component: () =>
            import("@/views/custom/Keq_UnmannedAerialVehicle/activityList.vue")
        }
      ]
    },
    // 课程自定义--突泉县中等职业学校--护理学基础
    {
      path: "/custom/Tqx_Nursing",
      name: "TqxNursing",
      component: () => import("@/views/custom/Tqx_Nursing/layout.vue"),
      redirect: "/custom/Tqx_Nursing/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TqxNursingHome",
          component: () => import("@/views/custom/Tqx_Nursing/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TqxNursingLearn",
          component: () => import("@/views/custom/Tqx_Nursing/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "TqxNursingCourseGeneralize",
          component: () =>
            import("@/views/custom/Tqx_Nursing/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "TqxNursingStandard",
          component: () => import("@/views/custom/Tqx_Nursing/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "TqxNursingTeachingTeam",
          component: () => import("@/views/custom/Tqx_Nursing/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "TqxNursingActivityList",
          component: () => import("@/views/custom/Tqx_Nursing/activityList.vue")
        }
      ]
    },
    // 课程自定义--突泉县中等职业学校--职业道德与法治
    {
      path: "/custom/Tqx_occupation",
      name: "TqxOccupation",
      component: () => import("@/views/custom/Tqx_occupation/layout.vue"),
      redirect: "/custom/Tqx_occupation/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TqxOccupationHome",
          component: () => import("@/views/custom/Tqx_occupation/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TqxOccupationLearn",
          component: () => import("@/views/custom/Tqx_occupation/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "TqxOccupationCourseGeneralize",
          component: () =>
            import("@/views/custom/Tqx_occupation/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "TqxOccupationStandard",
          component: () => import("@/views/custom/Tqx_occupation/standard.vue")
        },
        //教学团队
        {
          path: "teacher",
          name: "TqxOccupationTeacher",
          component: () => import("@/views/custom/Tqx_occupation/teacher.vue")
        },
        // 列表
        {
          path: "list",
          name: "TqxOccupationList",
          component: () => import("@/views/custom/Tqx_occupation/list.vue")
        }
      ]
    },
    // 课程自定义--突泉县中等职业学校--哲学与人生
    {
      path: "/custom/Tqx_philosophy",
      name: "TqxPhilosophy",
      component: () => import("@/views/custom/Tqx_philosophy/layout.vue"),
      redirect: "/custom/Tqx_philosophy/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TqxPhilosophyHome",
          component: () => import("@/views/custom/Tqx_philosophy/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TqxPhilosophyLearn",
          component: () => import("@/views/custom/Tqx_philosophy/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "TqxPhilosophyCourseGeneralize",
          component: () =>
            import("@/views/custom/Tqx_philosophy/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "TqxPhilosophyStandard",
          component: () => import("@/views/custom/Tqx_philosophy/standard.vue")
        },
        //教学团队
        {
          path: "teacher",
          name: "TqxPhilosophyTeacher",
          component: () => import("@/views/custom/Tqx_philosophy/teacher.vue")
        },
        // 列表
        {
          path: "list",
          name: "TqxPhilosophyList",
          component: () => import("@/views/custom/Tqx_philosophy/list.vue")
        }
      ]
    },
    // 课程自定义--突泉县中等职业学校--3D打印
    {
      path: "/custom/Tqx_print",
      name: "TqxPrint",
      component: () => import("@/views/custom/Tqx_Print/layout.vue"),
      redirect: "/custom/Tqx_Print/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TqxPrintHome",
          component: () => import("@/views/custom/Tqx_Print/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TqxPrintLearn",
          component: () => import("@/views/custom/Tqx_Print/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "TqxPrintCourseGeneralize",
          component: () =>
            import("@/views/custom/Tqx_Print/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "TqxPrintStandard",
          component: () => import("@/views/custom/Tqx_Print/standard.vue")
        },
        //教学团队
        {
          path: "teacher",
          name: "TqxPrintTeacher",
          component: () => import("@/views/custom/Tqx_Print/teacher.vue")
        },
        // 列表
        {
          path: "list",
          name: "TqxPrintList",
          component: () => import("@/views/custom/Tqx_Print/list.vue")
        }
      ]
    },
    // 课程自定义--突泉县中等职业学校--普通焊接方法
    {
      path: "/custom/Tqx_weld",
      name: "TqxWeld",
      component: () => import("@/views/custom/Tqx_Weld/layout.vue"),
      redirect: "/custom/Tqx_Weld/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TqxWeldHome",
          component: () => import("@/views/custom/Tqx_Weld/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TqxWeldLearn",
          component: () => import("@/views/custom/Tqx_Weld/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "TqxWeldCourseGeneralize",
          component: () =>
            import("@/views/custom/Tqx_Weld/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "TqxWeldStandard",
          component: () => import("@/views/custom/Tqx_Weld/standard.vue")
        },
        //教学团队
        {
          path: "teacher",
          name: "TqxWeldTeacher",
          component: () => import("@/views/custom/Tqx_Weld/teacher.vue")
        },
        // 列表
        {
          path: "list",
          name: "TqxWeldList",
          component: () => import("@/views/custom/Tqx_Weld/list.vue")
        }
      ]
    },
    // 课程自定义--突泉县中等职业学校--药理学
    {
      path: "/custom/Tqx_pharmacology",
      name: "TqxPharmacology",
      component: () => import("@/views/custom/Tqx_pharmacology/layout.vue"),
      redirect: "/custom/Tqx_pharmacology/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TqxPharmacologyHome",
          component: () => import("@/views/custom/Tqx_pharmacology/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TqxPharmacologyLearn",
          component: () => import("@/views/custom/Tqx_pharmacology/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "TqxPharmacologyCourseGeneralize",
          component: () =>
            import("@/views/custom/Tqx_pharmacology/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "TqxPharmacologyStandard",
          component: () =>
            import("@/views/custom/Tqx_pharmacology/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "TqxPharmacologyTeachingTeam",
          component: () =>
            import("@/views/custom/Tqx_pharmacology/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "TqxPharmacologyActivityList",
          component: () =>
            import("@/views/custom/Tqx_pharmacology/activityList.vue")
        }
      ]
    },
    // 课程自定义--突泉县中等职业学校--解剖学
    {
      path: "/custom/Tqx_Anatomy",
      name: "TqxAnatomy",
      component: () => import("@/views/custom/Tqx_Anatomy/layout.vue"),
      redirect: "/custom/Tqx_Anatomy/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TqxAnatomyHome",
          component: () => import("@/views/custom/Tqx_Anatomy/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TqxAnatomyLearn",
          component: () => import("@/views/custom/Tqx_Anatomy/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "TqxAnatomyCourseGeneralize",
          component: () =>
            import("@/views/custom/Tqx_Anatomy/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "TqxAnatomyStandard",
          component: () => import("@/views/custom/Tqx_Anatomy/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "TqxAnatomyTeachingTeam",
          component: () => import("@/views/custom/Tqx_Anatomy/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "TqxAnatomyActivityList",
          component: () => import("@/views/custom/Tqx_Anatomy/activityList.vue")
        }
      ]
    },
    // 课程自定义--突泉县中等职业学校--中国特色社会主义
    {
      path: "/custom/Tqx_Socialism",
      name: "TqxSocialism",
      component: () => import("@/views/custom/Tqx_Socialism/layout.vue"),
      redirect: "/custom/Tqx_Socialism/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TqxSocialismHome",
          component: () => import("@/views/custom/Tqx_Socialism/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TqxSocialismLearn",
          component: () => import("@/views/custom/Tqx_Socialism/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "TqxSocialismCourseGeneralize",
          component: () =>
            import("@/views/custom/Tqx_Socialism/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "TqxSocialismStandard",
          component: () => import("@/views/custom/Tqx_Socialism/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "TqxSocialismTeachingTeam",
          component: () =>
            import("@/views/custom/Tqx_Socialism/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "TqxSocialismActivityList",
          component: () =>
            import("@/views/custom/Tqx_Socialism/activityList.vue")
        }
      ]
    },
    // 课程自定义--突泉县中等职业学校--幼儿教育心理
    {
      path: "/custom/Tqx_PreschoolEducation",
      name: "TqxPreschoolEducation",
      component: () =>
        import("@/views/custom/Tqx_PreschoolEducation/layout.vue"),
      redirect: "/custom/Tqx_PreschoolEducation/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TqxPreschoolEducationHome",
          component: () =>
            import("@/views/custom/Tqx_PreschoolEducation/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TqxPreschoolEducationLearn",
          component: () =>
            import("@/views/custom/Tqx_PreschoolEducation/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "TqxPreschoolEducationCourseGeneralize",
          component: () =>
            import("@/views/custom/Tqx_PreschoolEducation/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "TqxPreschoolEducationStandard",
          component: () =>
            import("@/views/custom/Tqx_PreschoolEducation/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "TqxPreschoolEducationTeachingTeam",
          component: () =>
            import("@/views/custom/Tqx_PreschoolEducation/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "TqxPreschoolEducationActivityList",
          component: () =>
            import("@/views/custom/Tqx_PreschoolEducation/activityList.vue")
        }
      ]
    },
    // 课程自定义--突泉县中等职业学校--学前儿童卫生与保健
    {
      path: "/custom/Tqx_HealthWellness",
      name: "TqxHealthWellness",
      component: () => import("@/views/custom/Tqx_HealthWellness/layout.vue"),
      redirect: "/custom/Tqx_HealthWellness/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TqxHealthWellnessHome",
          component: () => import("@/views/custom/Tqx_HealthWellness/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TqxHealthWellnessLearn",
          component: () => import("@/views/custom/Tqx_HealthWellness/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "TqxHealthWellnessCourseGeneralize",
          component: () =>
            import("@/views/custom/Tqx_HealthWellness/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "TqxHealthWellnessStandard",
          component: () =>
            import("@/views/custom/Tqx_HealthWellness/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "TqxHealthWellnessTeachingTeam",
          component: () =>
            import("@/views/custom/Tqx_HealthWellness/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "TqxHealthWellnessActivityList",
          component: () =>
            import("@/views/custom/Tqx_HealthWellness/activityList.vue")
        }
      ]
    },
    // 课程自定义--突泉县中等职业学校--中国旅游地理
    {
      path: "/custom/Tqx_Travel",
      name: "TqxTravel",
      component: () => import("@/views/custom/Tqx_Travel/layout.vue"),
      redirect: "/custom/Tqx_Travel/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TqxTravelHome",
          component: () => import("@/views/custom/Tqx_Travel/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TqxTravelLearn",
          component: () => import("@/views/custom/Tqx_Travel/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "TqxTravelCourseGeneralize",
          component: () =>
            import("@/views/custom/Tqx_Travel/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "TqxTravelStandard",
          component: () => import("@/views/custom/Tqx_Travel/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "TqxTravelTeachingTeam",
          component: () => import("@/views/custom/Tqx_Travel/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "TqxTravelActivityList",
          component: () => import("@/views/custom/Tqx_Travel/activityList.vue")
        }
      ]
    },
    // 课程自定义--突泉县中等职业学校--计算机组装与维护
    {
      path: "/custom/Tqx_AssemblyMaintenance",
      name: "TqxAssemblyMaintenance",
      component: () =>
        import("@/views/custom/Tqx_AssemblyMaintenance/layout.vue"),
      redirect: "/custom/Tqx_AssemblyMaintenance/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TqxAssemblyMaintenanceHome",
          component: () =>
            import("@/views/custom/Tqx_AssemblyMaintenance/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TqxAssemblyMaintenanceLearn",
          component: () =>
            import("@/views/custom/Tqx_AssemblyMaintenance/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "TqxAssemblyMaintenanceCourseGeneralize",
          component: () =>
            import(
              "@/views/custom/Tqx_AssemblyMaintenance/courseGeneralize.vue"
            )
        },
        //其他页
        {
          path: "standard",
          name: "TqxAssemblyMaintenanceStandard",
          component: () =>
            import("@/views/custom/Tqx_AssemblyMaintenance/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "TqxAssemblyMaintenanceTeachingTeam",
          component: () =>
            import("@/views/custom/Tqx_AssemblyMaintenance/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "TqxAssemblyMaintenanceActivityList",
          component: () =>
            import("@/views/custom/Tqx_AssemblyMaintenance/activityList.vue")
        }
      ]
    },
    // 课程自定义--突泉县中等职业学校--电工技术基础与技能
    {
      path: "/custom/Tqx_Electrotechnics",
      name: "TqxElectrotechnics",
      component: () => import("@/views/custom/Tqx_Electrotechnics/layout.vue"),
      redirect: "/custom/Tqx_Electrotechnics/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TqxElectrotechnicsHome",
          component: () => import("@/views/custom/Tqx_Electrotechnics/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TqxElectrotechnicsLearn",
          component: () =>
            import("@/views/custom/Tqx_Electrotechnics/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "TqxElectrotechnicsCourseGeneralize",
          component: () =>
            import("@/views/custom/Tqx_Electrotechnics/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "TqxElectrotechnicsStandard",
          component: () =>
            import("@/views/custom/Tqx_Electrotechnics/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "TqxElectrotechnicsTeachingTeam",
          component: () =>
            import("@/views/custom/Tqx_Electrotechnics/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "TqxElectrotechnicsActivityList",
          component: () =>
            import("@/views/custom/Tqx_Electrotechnics/activityList.vue")
        }
      ]
    },
    // 课程自定义--突泉县中等职业学校--汽车底盘构造与维修
    {
      path: "/custom/Tqx_AutomotiveChassis",
      name: "TqxAutomotiveChassis",
      component: () =>
        import("@/views/custom/Tqx_AutomotiveChassis/layout.vue"),
      redirect: "/custom/Tqx_AutomotiveChassis/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TqxAutomotiveChassisHome",
          component: () =>
            import("@/views/custom/Tqx_AutomotiveChassis/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TqxAutomotiveChassisLearn",
          component: () =>
            import("@/views/custom/Tqx_AutomotiveChassis/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "TqxAutomotiveChassisCourseGeneralize",
          component: () =>
            import("@/views/custom/Tqx_AutomotiveChassis/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "TqxAutomotiveChassisStandard",
          component: () =>
            import("@/views/custom/Tqx_AutomotiveChassis/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "TqxAutomotiveChassisTeachingTeam",
          component: () =>
            import("@/views/custom/Tqx_AutomotiveChassis/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "TqxAutomotiveChassisActivityList",
          component: () =>
            import("@/views/custom/Tqx_AutomotiveChassis/activityList.vue")
        }
      ]
    },
    // 课程自定义--突泉县中等职业学校--幼儿活动指导
    {
      path: "/custom/Tqx_ChildActivity",
      name: "TqxChildActivity",
      component: () => import("@/views/custom/Tqx_ChildActivity/layout.vue"),
      redirect: "/custom/Tqx_ChildActivity/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TqxChildActivityHome",
          component: () => import("@/views/custom/Tqx_ChildActivity/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TqxChildActivityLearn",
          component: () => import("@/views/custom/Tqx_ChildActivity/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "TqxChildActivityCourseGeneralize",
          component: () =>
            import("@/views/custom/Tqx_ChildActivity/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "TqxChildActivityStandard",
          component: () =>
            import("@/views/custom/Tqx_ChildActivity/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "TqxChildActivityTeachingTeam",
          component: () =>
            import("@/views/custom/Tqx_ChildActivity/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "TqxChildActivityActivityList",
          component: () =>
            import("@/views/custom/Tqx_ChildActivity/activityList.vue")
        }
      ]
    },
    // 课程自定义--突泉县中等职业学校--电子技术基础
    {
      path: "/custom/Tqx_ElectronicTechnique",
      name: "TqxElectronicTechnique",
      component: () =>
        import("@/views/custom/Tqx_ElectronicTechnique/layout.vue"),
      redirect: "/custom/Tqx_ElectronicTechnique/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TqxElectronicTechniqueHome",
          component: () =>
            import("@/views/custom/Tqx_ElectronicTechnique/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TqxElectronicTechniqueLearn",
          component: () =>
            import("@/views/custom/Tqx_ElectronicTechnique/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "TqxElectronicTechniqueCourseGeneralize",
          component: () =>
            import(
              "@/views/custom/Tqx_ElectronicTechnique/courseGeneralize.vue"
            )
        },
        //其他页
        {
          path: "standard",
          name: "TqxElectronicTechniqueStandard",
          component: () =>
            import("@/views/custom/Tqx_ElectronicTechnique/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "TqxElectronicTechniqueTeachingTeam",
          component: () =>
            import("@/views/custom/Tqx_ElectronicTechnique/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "TqxElectronicTechniqueActivityList",
          component: () =>
            import("@/views/custom/Tqx_ElectronicTechnique/activityList.vue")
        }
      ]
    },
    // 课程自定义--突泉县中等职业学校--生理学
    {
      path: "/custom/Tqx_Physiology",
      name: "TqxPhysiology",
      component: () => import("@/views/custom/Tqx_Physiology/layout.vue"),
      redirect: "/custom/Tqx_Physiology/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TqxPhysiologyHome",
          component: () => import("@/views/custom/Tqx_Physiology/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TqxPhysiologyLearn",
          component: () => import("@/views/custom/Tqx_Physiology/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "TqxPhysiologyCourseGeneralize",
          component: () =>
            import("@/views/custom/Tqx_Physiology/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "TqxPhysiologyStandard",
          component: () => import("@/views/custom/Tqx_Physiology/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "TqxPhysiologyTeachingTeam",
          component: () =>
            import("@/views/custom/Tqx_Physiology/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "TqxPhysiologyActivityList",
          component: () =>
            import("@/views/custom/Tqx_Physiology/activityList.vue")
        }
      ]
    },
    // 课程自定义--突泉县中等职业学校--心理健康与职业生涯
    {
      path: "/custom/Tqx_MentalHealth",
      name: "TqxMentalHealth",
      component: () => import("@/views/custom/Tqx_MentalHealth/layout.vue"),
      redirect: "/custom/Tqx_MentalHealth/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TqxMentalHealthHome",
          component: () => import("@/views/custom/Tqx_MentalHealth/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TqxMentalHealthLearn",
          component: () => import("@/views/custom/Tqx_MentalHealth/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "TqxMentalHealthCourseGeneralize",
          component: () =>
            import("@/views/custom/Tqx_MentalHealth/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "TqxMentalHealthStandard",
          component: () =>
            import("@/views/custom/Tqx_MentalHealth/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "TqxMentalHealthTeachingTeam",
          component: () =>
            import("@/views/custom/Tqx_MentalHealth/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "TqxMentalHealthActivityList",
          component: () =>
            import("@/views/custom/Tqx_MentalHealth/activityList.vue")
        }
      ]
    },
    // 课程自定义--突泉县中等职业学校--病理学
    {
      path: "/custom/Tqx_Pathology",
      name: "TqxPathology",
      component: () => import("@/views/custom/Tqx_Pathology/layout.vue"),
      redirect: "/custom/Tqx_Pathology/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TqxPathologyHome",
          component: () => import("@/views/custom/Tqx_Pathology/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TqxPathologyLearn",
          component: () => import("@/views/custom/Tqx_Pathology/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "TqxPathologyCourseGeneralize",
          component: () =>
            import("@/views/custom/Tqx_Pathology/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "TqxPathologyStandard",
          component: () => import("@/views/custom/Tqx_Pathology/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "TqxPathologyTeachingTeam",
          component: () =>
            import("@/views/custom/Tqx_Pathology/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "TqxPathologyActivityList",
          component: () =>
            import("@/views/custom/Tqx_Pathology/activityList.vue")
        }
      ]
    },
    // 课程自定义--乌海市职业技术学院--电力拖动控制线路
    {
      path: "/custom/Whs_electricity",
      name: "WhsElectricity",
      component: () => import("@/views/custom/Whs_electricity/layout.vue"),
      redirect: "/custom/Whs_electricity/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "WhsElectricityHome",
          component: () => import("@/views/custom/Whs_electricity/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "WhsElectricityLearn",
          component: () => import("@/views/custom/Whs_electricity/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "WhsElectricityCourseGeneralize",
          component: () =>
            import("@/views/custom/Whs_electricity/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "WhsElectricityStandard",
          component: () => import("@/views/custom/Whs_electricity/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "WhsElectricityTeachingTeam",
          component: () =>
            import("@/views/custom/Whs_electricity/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "WhsElectricityActivityList",
          component: () =>
            import("@/views/custom/Whs_electricity/activityList.vue")
        }
      ]
    },
    // 课程自定义--乌海市职业技术学院--汽车发动机维修
    {
      path: "/custom/Whs_engine",
      name: "WhsEngine",
      component: () => import("@/views/custom/Whs_engine/layout.vue"),
      redirect: "/custom/Whs_engine/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "WhsEngineHome",
          component: () => import("@/views/custom/Whs_engine/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "WhsEngineLearn",
          component: () => import("@/views/custom/Whs_engine/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "WhsEngineCourseGeneralize",
          component: () =>
            import("@/views/custom/Whs_engine/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "WhsEngineStandard",
          component: () => import("@/views/custom/Whs_engine/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "WhsEngineTeachingTeam",
          component: () => import("@/views/custom/Whs_engine/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "WhsEngineActivityList",
          component: () => import("@/views/custom/Whs_engine/activityList.vue")
        }
      ]
    },
    // 课程自定义--乌海市职业技术学院--书法
    {
      path: "/custom/Whs_calligraphy",
      name: "WhsCalligraphy",
      component: () => import("@/views/custom/Whs_calligraphy/layout.vue"),
      redirect: "/custom/Whs_calligraphy/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "WhsCalligraphyHome",
          component: () => import("@/views/custom/Whs_calligraphy/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "WhsCalligraphyLearn",
          component: () => import("@/views/custom/Whs_calligraphy/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "WhsCalligraphyCourseGeneralize",
          component: () =>
            import("@/views/custom/Whs_calligraphy/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "WhsCalligraphyStandard",
          component: () => import("@/views/custom/Whs_calligraphy/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "WhsCalligraphyTeachingTeam",
          component: () =>
            import("@/views/custom/Whs_calligraphy/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "WhsCalligraphyActivityList",
          component: () =>
            import("@/views/custom/Whs_calligraphy/activityList.vue")
        }
      ]
    },
    // 课程自定义--乌海市职业技术学院--幼儿文学
    {
      path: "/custom/Whs_childScience",
      name: "WhsChildScience",
      component: () => import("@/views/custom/Whs_childScience/layout.vue"),
      redirect: "/custom/Whs_engine/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "WhsChildScienceHome",
          component: () => import("@/views/custom/Whs_childScience/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "WhsChildScienceLearn",
          component: () => import("@/views/custom/Whs_childScience/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "WhsChildScienceCourseGeneralize",
          component: () =>
            import("@/views/custom/Whs_childScience/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "WhsChildScienceStandard",
          component: () =>
            import("@/views/custom/Whs_childScience/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "WhsChildScienceTeachingTeam",
          component: () =>
            import("@/views/custom/Whs_childScience/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "WhsChildScienceActivityList",
          component: () =>
            import("@/views/custom/Whs_childScience/activityList.vue")
        }
      ]
    },
    // 课程自定义--乌海市职业技术学校--职业道德与法治
    {
      path: "/custom/Whs_occupation",
      name: "WhsOccupation",
      component: () => import("@/views/custom/Whs_occupation/layout.vue"),
      redirect: "/custom/Whs_occupation/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "WhsOccupationHome",
          component: () => import("@/views/custom/Whs_occupation/home.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "WhsOccupationCourseGeneralize",
          component: () =>
            import("@/views/custom/Whs_occupation/courseGeneralize.vue")
        },
        //教学团队
        {
          path: "teacher",
          name: "WhsOccupationTeacher",
          component: () => import("@/views/custom/Whs_occupation/teacher.vue")
        },
        // 列表
        {
          path: "list",
          name: "WhsOccupationList",
          component: () => import("@/views/custom/Whs_occupation/list.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "WhsOccupationLearn",
          component: () => import("@/views/custom/Whs_occupation/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "WhsOccupationStandard",
          component: () => import("@/views/custom/Whs_occupation/standard.vue")
        }
      ]
    },
    //
    // 课程自定义-- 杭锦后旗职业教育中心--护理学基础
    {
      path: "/custom/Hjhq_Nursing",
      name: "HjhqNursing",
      component: () => import("@/views/custom/Hjhq_Nursing/layout.vue"),
      redirect: "/custom/Hjhq_Nursing/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "HjhqNursingHome",
          component: () => import("@/views/custom/Hjhq_Nursing/home.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "HjhqNursingCourseGeneralize",
          component: () =>
            import("@/views/custom/Hjhq_Nursing/courseGeneralize.vue")
        },
        //教学团队
        {
          path: "teacher",
          name: "HjhqNursingTeacher",
          component: () => import("@/views/custom/Hjhq_Nursing/teacher.vue")
        },
        // 列表
        {
          path: "list",
          name: "HjhqNursingList",
          component: () => import("@/views/custom/Hjhq_Nursing/list.vue")
        },
        //其他页
        {
          path: "standard",
          name: "HjhqNursingStandard",
          component: () => import("@/views/custom/Hjhq_Nursing/standard.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "HjhqNursingLearn",
          component: () => import("@/views/custom/Hjhq_Nursing/learn.vue")
        }
      ]
    },
    // 课程自定义-- 杭锦后旗职业教育中心--植物生产与环境
    {
      path: "/custom/Hjhq_Plant",
      name: "HjhqPlant",
      component: () => import("@/views/custom/Hjhq_Plant/layout.vue"),
      redirect: "/custom/Hjhq_Plant/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "HjhqPlantHome",
          component: () => import("@/views/custom/Hjhq_Plant/home.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "HjhqPlantCourseGeneralize",
          component: () =>
            import("@/views/custom/Hjhq_Plant/courseGeneralize.vue")
        },
        //教学团队
        {
          path: "teacher",
          name: "HjhqPlantTeacher",
          component: () => import("@/views/custom/Hjhq_Plant/teacher.vue")
        },
        // 列表
        {
          path: "list",
          name: "HjhqPlantList",
          component: () => import("@/views/custom/Hjhq_Plant/list.vue")
        },
        //其他页
        {
          path: "standard",
          name: "HjhqPlantStandard",
          component: () => import("@/views/custom/Hjhq_Plant/standard.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "HjhqPlantLearn",
          component: () => import("@/views/custom/Hjhq_Plant/learn.vue")
        }
      ]
    },
    // 课程自定义-- 阿荣旗职业技术学院--植物生产与环境
    {
      path: "/custom/Arq_Plant",
      name: "ArqPlant",
      component: () => import("@/views/custom/Arq_Plant/layout.vue"),
      redirect: "/custom/Arq_Plant/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "ArqPlantHome",
          component: () => import("@/views/custom/Arq_Plant/home.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "ArqPlantCourseGeneralize",
          component: () =>
            import("@/views/custom/Arq_Plant/courseGeneralize.vue")
        },
        // 列表
        {
          path: "list",
          name: "ArqPlantList",
          component: () => import("@/views/custom/Arq_Plant/list.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "ArqPlantLearn",
          component: () => import("@/views/custom/Arq_Plant/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "ArqPlantStandard",
          component: () => import("@/views/custom/Arq_Plant/standard.vue")
        },
        //教学团队
        {
          path: "teacher",
          name: "ArqPlantTeacher",
          component: () => import("@/views/custom/Arq_Plant/teacher.vue")
        }
      ]
    },
    // 课程自定义--课程思政--职业道德和法制
    {
      path: "/custom/Szkc_Morality",
      name: "SzkcMorality",
      component: () => import("@/views/custom/Szkc_Morality/layout.vue"),
      redirect: "/custom/Szkc_Morality/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "SzkcMoralityHome",
          component: () => import("@/views/custom/Szkc_Morality/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "SzkcMoralityLearn",
          component: () => import("@/views/custom/Szkc_Morality/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "SzkcMoralityStandard",
          component: () => import("@/views/custom/Szkc_Morality/standard.vue")
        },
        //其他页
        {
          path: "list",
          name: "SzkcMoralityList",
          component: () => import("@/views/custom/Szkc_Morality/list.vue")
        }
      ]
    },
    // 课程自定义---心理健康与职业生涯
    {
      path: "/custom/Szkc_Mentalhealth",
      name: "SzkcMentalhealth",
      component: () => import("@/views/custom/Szkc_Mentalhealth/layout.vue"),
      redirect: "/custom/Szkc_Mentalhealth/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "SzkcMentalhealthHome",
          component: () => import("@/views/custom/Szkc_Mentalhealth/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "SzkcMentalhealthLearn",
          component: () => import("@/views/custom/Szkc_Mentalhealth/learn.vue")
        },
        //企业案例
        {
          path: "standard",
          name: "SzkcMentalhealthstandard",
          component: () =>
            import("@/views/custom/Szkc_Mentalhealth/standard.vue")
        },
        //文字列表
        {
          path: "list",
          name: "SzkcMentalhealthList",
          component: () => import("@/views/custom/Szkc_Mentalhealth/list.vue")
        },
        //其他教师列表
        {
          path: "teacherList",
          name: "SzkcMentalhealthTeacherList",
          component: () =>
            import("@/views/custom/Szkc_Mentalhealth/teacherList.vue")
        },
        //其他教师详情
        {
          path: "teacherDetail",
          name: "SzkcMentalhealthTeacherDetail",
          component: () =>
            import("@/views/custom/Szkc_Mentalhealth/teacherDetail.vue")
        }
      ]
    },
    // 课程自定义--思政课程--哲学人生
    {
      path: "/custom/Szkc_Philosophy",
      name: "SzkcPhilosophy",
      component: () => import("@/views/custom/Szkc_Philosophy/layout.vue"),
      redirect: "/custom/Szkc_Philosophy/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "SzkcPhilosophyHome",
          component: () => import("@/views/custom/Szkc_Philosophy/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "SzkcPhilosophyLearn",
          component: () => import("@/views/custom/Szkc_Philosophy/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "SzkcPhilosophystandard",
          component: () => import("@/views/custom/Szkc_Philosophy/standard.vue")
        }
      ]
    },
    // 课程自定义--曲沃县中等职业技术学院--直播电商基础
    {
      path: "/custom/Qwx_LiveEcommerce",
      name: "QwxLiveEcommerce",
      component: () => import("@/views/custom/Qwx_LiveEcommerce/layout.vue"),
      redirect: "/custom/Qwx_LiveEcommerce/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "QwxLiveEcommerceHome",
          component: () => import("@/views/custom/Qwx_LiveEcommerce/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "QwxLiveEcommerceLearn",
          component: () => import("@/views/custom/Qwx_LiveEcommerce/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "QwxLiveEcommerceCourseGeneralize",
          component: () =>
            import("@/views/custom/Qwx_LiveEcommerce/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "QwxLiveEcommerceStandard",
          component: () =>
            import("@/views/custom/Qwx_LiveEcommerce/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "QwxLiveEcommerceTeachingTeam",
          component: () =>
            import("@/views/custom/Qwx_LiveEcommerce/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "QwxLiveEcommerceActivityList",
          component: () =>
            import("@/views/custom/Qwx_LiveEcommerce/activityList.vue")
        }
      ]
    },
    // 课程自定义--曲沃县中等职业技术学院--wps办公应用
    {
      path: "/custom/Qwx_OfficeApplication",
      name: "QwxOfficeApplication",
      component: () =>
        import("@/views/custom/Qwx_OfficeApplication/layout.vue"),
      redirect: "/custom/Qwx_OfficeApplication/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "QwxOfficeApplicationHome",
          component: () =>
            import("@/views/custom/Qwx_OfficeApplication/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "QwxOfficeApplicationLearn",
          component: () =>
            import("@/views/custom/Qwx_OfficeApplication/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "QwxOfficeApplicationCourseGeneralize",
          component: () =>
            import("@/views/custom/Qwx_OfficeApplication/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "QwxOfficeApplicationStandard",
          component: () =>
            import("@/views/custom/Qwx_OfficeApplication/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "QwxOfficeApplicationTeachingTeam",
          component: () =>
            import("@/views/custom/Qwx_OfficeApplication/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "QwxOfficeApplicationActivityList",
          component: () =>
            import("@/views/custom/Qwx_OfficeApplication/activityList.vue")
        }
      ]
    },
    // 课程自定义--曲沃县中等职业技术学院--市场营销
    {
      path: "/custom/Qwx_Marketing",
      name: "QwxMarketing",
      component: () => import("@/views/custom/Qwx_Marketing/layout.vue"),
      redirect: "/custom/Qwx_Marketing/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "QwxMarketingHome",
          component: () => import("@/views/custom/Qwx_Marketing/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "QwxMarketingLearn",
          component: () => import("@/views/custom/Qwx_Marketing/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "QwxMarketingCourseGeneralize",
          component: () =>
            import("@/views/custom/Qwx_Marketing/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "QwxMarketingStandard",
          component: () => import("@/views/custom/Qwx_Marketing/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "QwxMarketingTeachingTeam",
          component: () =>
            import("@/views/custom/Qwx_Marketing/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "QwxMarketingActivityList",
          component: () =>
            import("@/views/custom/Qwx_Marketing/activityList.vue")
        }
      ]
    },
    // 课程自定义--曲沃县中等职业技术学院--电子商务数据分析基础
    {
      path: "/custom/Qwx_EcommerceDataAnalysis",
      name: "QwxEcommerceDataAnalysis",
      component: () =>
        import("@/views/custom/Qwx_EcommerceDataAnalysis/layout.vue"),
      redirect: "/custom/Qwx_EcommerceDataAnalysis/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "QwxEcommerceDataAnalysisHome",
          component: () =>
            import("@/views/custom/Qwx_EcommerceDataAnalysis/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "QwxEcommerceDataAnalysisLearn",
          component: () =>
            import("@/views/custom/Qwx_EcommerceDataAnalysis/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "QwxEcommerceDataAnalysisCourseGeneralize",
          component: () =>
            import(
              "@/views/custom/Qwx_EcommerceDataAnalysis/courseGeneralize.vue"
            )
        },
        //其他页
        {
          path: "standard",
          name: "QwxEcommerceDataAnalysisStandard",
          component: () =>
            import("@/views/custom/Qwx_EcommerceDataAnalysis/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "QwxEcommerceDataAnalysisTeachingTeam",
          component: () =>
            import("@/views/custom/Qwx_EcommerceDataAnalysis/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "QwxEcommerceDataAnalysisActivityList",
          component: () =>
            import("@/views/custom/Qwx_EcommerceDataAnalysis/activityList.vue")
        }
      ]
    },
    // 课程自定义--曲沃县中等职业技术学院--pr视频剪辑
    {
      path: "/custom/Qwx_PrVideoEditing",
      name: "QwxPrVideoEditing",
      component: () => import("@/views/custom/Qwx_PrVideoEditing/layout.vue"),
      redirect: "/custom/Qwx_PrVideoEditing/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "QwxPrVideoEditingHome",
          component: () => import("@/views/custom/Qwx_PrVideoEditing/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "QwxPrVideoEditingLearn",
          component: () => import("@/views/custom/Qwx_PrVideoEditing/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "QwxPrVideoEditingCourseGeneralize",
          component: () =>
            import("@/views/custom/Qwx_PrVideoEditing/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "QwxPrVideoEditingStandard",
          component: () =>
            import("@/views/custom/Qwx_PrVideoEditing/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "QwxPrVideoEditingTeachingTeam",
          component: () =>
            import("@/views/custom/Qwx_PrVideoEditing/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "QwxPrVideoEditingActivityList",
          component: () =>
            import("@/views/custom/Qwx_PrVideoEditing/activityList.vue")
        }
      ]
    },
    // 课程自定义--曲沃县中等职业技术学院--计算机网络基础
    {
      path: "/custom/Qwx_ComputerNetworkBasis",
      name: "QwxComputerNetworkBasis",
      component: () =>
        import("@/views/custom/Qwx_ComputerNetworkBasis/layout.vue"),
      redirect: "/custom/Qwx_ComputerNetworkBasis/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "QwxComputerNetworkBasisHome",
          component: () =>
            import("@/views/custom/Qwx_ComputerNetworkBasis/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "QwxComputerNetworkBasisLearn",
          component: () =>
            import("@/views/custom/Qwx_ComputerNetworkBasis/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "QwxComputerNetworkBasisCourseGeneralize",
          component: () =>
            import(
              "@/views/custom/Qwx_ComputerNetworkBasis/courseGeneralize.vue"
            )
        },
        //其他页
        {
          path: "standard",
          name: "QwxComputerNetworkBasisStandard",
          component: () =>
            import("@/views/custom/Qwx_ComputerNetworkBasis/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "QwxComputerNetworkBasisTeachingTeam",
          component: () =>
            import("@/views/custom/Qwx_ComputerNetworkBasis/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "QwxComputerNetworkBasisActivityList",
          component: () =>
            import("@/views/custom/Qwx_ComputerNetworkBasis/activityList.vue")
        }
      ]
    },
    // 课程自定义--曲沃县中等职业技术学院--网店运营设计
    {
      path: "/custom/Qwx_OnlineShopOperation",
      name: "QwxOnlineShopOperation",
      component: () =>
        import("@/views/custom/Qwx_OnlineShopOperation/layout.vue"),
      redirect: "/custom/Qwx_OnlineShopOperation/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "QwxOnlineShopOperationHome",
          component: () =>
            import("@/views/custom/Qwx_OnlineShopOperation/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "QwxOnlineShopOperationLearn",
          component: () =>
            import("@/views/custom/Qwx_OnlineShopOperation/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "QwxOnlineShopOperationCourseGeneralize",
          component: () =>
            import(
              "@/views/custom/Qwx_OnlineShopOperation/courseGeneralize.vue"
            )
        },
        //其他页
        {
          path: "standard",
          name: "QwxOnlineShopOperationStandard",
          component: () =>
            import("@/views/custom/Qwx_OnlineShopOperation/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "QwxOnlineShopOperationTeachingTeam",
          component: () =>
            import("@/views/custom/Qwx_OnlineShopOperation/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "QwxOnlineShopOperationActivityList",
          component: () =>
            import("@/views/custom/Qwx_OnlineShopOperation/activityList.vue")
        }
      ]
    },
    // 课程自定义--曲沃县中等职业技术学院--电商客服
    {
      path: "/custom/Qwx_EcommerceService",
      name: "QwxEcommerceService",
      component: () => import("@/views/custom/Qwx_EcommerceService/layout.vue"),
      redirect: "/custom/Qwx_EcommerceService/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "QwxEcommerceServiceHome",
          component: () =>
            import("@/views/custom/Qwx_EcommerceService/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "QwxEcommerceServiceLearn",
          component: () =>
            import("@/views/custom/Qwx_EcommerceService/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "QwxEcommerceServiceCourseGeneralize",
          component: () =>
            import("@/views/custom/Qwx_EcommerceService/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "QwxEcommerceServiceStandard",
          component: () =>
            import("@/views/custom/Qwx_EcommerceService/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "QwxEcommerceServiceTeachingTeam",
          component: () =>
            import("@/views/custom/Qwx_EcommerceService/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "QwxEcommerceServiceActivityList",
          component: () =>
            import("@/views/custom/Qwx_EcommerceService/activityList.vue")
        }
      ]
    },
    // 课程自定义--曲沃县中等职业技术学院--商品拍摄
    {
      path: "/custom/Qwx_MerchandiseShooting",
      name: "QwxMerchandiseShooting",
      component: () =>
        import("@/views/custom/Qwx_MerchandiseShooting/layout.vue"),
      redirect: "/custom/Qwx_MerchandiseShooting/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "QwxMerchandiseShootingHome",
          component: () =>
            import("@/views/custom/Qwx_MerchandiseShooting/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "QwxMerchandiseShootingLearn",
          component: () =>
            import("@/views/custom/Qwx_MerchandiseShooting/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "QwxMerchandiseShootingCourseGeneralize",
          component: () =>
            import(
              "@/views/custom/Qwx_MerchandiseShooting/courseGeneralize.vue"
            )
        },
        //其他页
        {
          path: "standard",
          name: "QwxMerchandiseShootingStandard",
          component: () =>
            import("@/views/custom/Qwx_MerchandiseShooting/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "QwxMerchandiseShootingTeachingTeam",
          component: () =>
            import("@/views/custom/Qwx_MerchandiseShooting/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "QwxMerchandiseShootingActivityList",
          component: () =>
            import("@/views/custom/Qwx_MerchandiseShooting/activityList.vue")
        }
      ]
    },
    // 课程自定义--曲沃县中等职业技术学院--视频编辑
    {
      path: "/custom/Qwx_VideoEditing",
      name: "QwxVideoEditing",
      component: () => import("@/views/custom/Qwx_VideoEditing/layout.vue"),
      redirect: "/custom/Qwx_VideoEditing/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "QwxVideoEditingHome",
          component: () => import("@/views/custom/Qwx_VideoEditing/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "QwxVideoEditingLearn",
          component: () => import("@/views/custom/Qwx_VideoEditing/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "QwxVideoEditingCourseGeneralize",
          component: () =>
            import("@/views/custom/Qwx_VideoEditing/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "QwxVideoEditingStandard",
          component: () =>
            import("@/views/custom/Qwx_VideoEditing/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "QwxVideoEditingTeachingTeam",
          component: () =>
            import("@/views/custom/Qwx_VideoEditing/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "QwxVideoEditingActivityList",
          component: () =>
            import("@/views/custom/Qwx_VideoEditing/activityList.vue")
        }
      ]
    },
    // 课程自定义--阳城县高级职业中学校--图形图像处理
    {
      path: "/custom/Ycx_graphicImage",
      name: "YcxGraphicImage",
      component: () => import("@/views/custom/Ycx_graphicImage/layout.vue"),
      redirect: "/custom/Ycx_graphicImage/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "YcxGraphicImageHome",
          component: () => import("@/views/custom/Ycx_graphicImage/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "YcxGraphicImageLearn",
          component: () => import("@/views/custom/Ycx_graphicImage/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "YcxGraphicImageCourseGeneralize",
          component: () =>
            import("@/views/custom/Ycx_graphicImage/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "YcxGraphicImageStandard",
          component: () =>
            import("@/views/custom/Ycx_graphicImage/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "YcxGraphicImageTeachingTeam",
          component: () =>
            import("@/views/custom/Ycx_graphicImage/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "YcxGraphicImageActivityList",
          component: () =>
            import("@/views/custom/Ycx_graphicImage/activityList.vue")
        }
      ]
    },
    // 课程自定义--太原卫生学院--老年护理
    {
      path: "/custom/Tyws_agedNursing",
      name: "TywsAgedNursing",
      component: () => import("@/views/custom/Tyws_agedNursing/layout.vue"),
      redirect: "/custom/Tyws_agedNursing/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TywsAgedNursingHome",
          component: () => import("@/views/custom/Tyws_agedNursing/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TywsAgedNursingLearn",
          component: () => import("@/views/custom/Tyws_agedNursing/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "TywsAgedNursingStandard",
          component: () =>
            import("@/views/custom/Tyws_agedNursing/standard.vue")
        },
        //实训环境
        {
          path: "training",
          name: "TywsAgedNursingTraining",
          component: () =>
            import("@/views/custom/Tyws_agedNursing/training.vue")
        },
        //实训环境
        {
          path: "courseDetails",
          name: "TywsAgedNursingDetails",
          component: () =>
            import("@/views/custom/Tyws_agedNursing/courseDetails.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "TywsAgedNursingCourseGeneralize",
          component: () =>
            import("@/views/custom/Tyws_emergencyCare/courseGeneralize.vue")
        }
      ]
    },
    // 课程自定义--太原卫生学院--急救护理技术
    {
      path: "/custom/Tyws_emergencyCare",
      name: "TywsEmergencyCare",
      component: () => import("@/views/custom/Tyws_emergencyCare/layout.vue"),
      redirect: "/custom/Tyws_agedNursing/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TywsEmergencyCareHome",
          component: () => import("@/views/custom/Tyws_emergencyCare/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TywsEmergencyCareLearn",
          component: () => import("@/views/custom/Tyws_emergencyCare/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "TywsEmergencyCareStandard",
          component: () =>
            import("@/views/custom/Tyws_emergencyCare/standard.vue")
        },
        //实训环境
        {
          path: "training",
          name: "TywsEmergencyCareTraining",
          component: () =>
            import("@/views/custom/Tyws_emergencyCare/training.vue")
        },
        //实训环境
        {
          path: "courseDetails",
          name: "TywsEmergencyCareDetails",
          component: () =>
            import("@/views/custom/Tyws_emergencyCare/courseDetails.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "TywsEmergencyCareCourseGeneralize",
          component: () =>
            import("@/views/custom/Tyws_emergencyCare/courseGeneralize.vue")
        }
      ]
    },
    // 课程自定义--果洛州职业技术学院--会展服务与管理
    {
      path: "/custom/Glz_exhibitionService",

      name: "GlzExhibitionService",
      component: () =>
        import("@/views/custom/Glz_exhibitionService/layout.vue"),
      redirect: "/custom/Glz_exhibitionService/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "GlzExhibitionServiceHome",
          component: () =>
            import("@/views/custom/Glz_exhibitionService/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "GlzExhibitionServiceLearn",
          component: () =>
            import("@/views/custom/Glz_exhibitionService/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "GlzExhibitionServiceStandard",
          component: () =>
            import("@/views/custom/Glz_exhibitionService/standard.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "GlzExhibitionServiceCourseGeneralize",
          component: () =>
            import("@/views/custom/Glz_exhibitionService/courseGeneralize.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "GlzExhibitionServiceTeachingTeam",
          component: () =>
            import("@/views/custom/Glz_exhibitionService/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--果洛州职业技术学院--客房服务与管理
    {
      path: "/custom/Glz_roomService",
      name: "GlzRoomService",
      component: () => import("@/views/custom/Glz_roomService/layout.vue"),
      redirect: "/custom/Glz_roomService/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "GlzRoomServiceHome",
          component: () => import("@/views/custom/Glz_roomService/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "GlzRoomServiceLearn",
          component: () => import("@/views/custom/Glz_roomService/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "GlzRoomServiceStandard",
          component: () => import("@/views/custom/Glz_roomService/standard.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "GlzRoomServiceCourseGeneralize",
          component: () =>
            import("@/views/custom/Glz_roomService/courseGeneralize.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "GlzRoomServiceTeachingTeam",
          component: () =>
            import("@/views/custom/Glz_roomService/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--大通市职业技术学院--中西面点
    {
      path: "/custom/Dtx_chineseWestern",

      name: "DtxChineseWestern",
      component: () => import("@/views/custom/Dtx_chineseWestern/layout.vue"),
      redirect: "/custom/Dtx_chineseWestern/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "DtxChineseWesternHome",
          component: () => import("@/views/custom/Dtx_chineseWestern/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "DtxChineseWesternLearn",
          component: () => import("@/views/custom/Dtx_chineseWestern/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "DtxChineseWesternStandard",
          component: () =>
            import("@/views/custom/Dtx_chineseWestern/standard.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "DtxChineseWesternCourseGeneralize",
          component: () =>
            import("@/views/custom/Dtx_chineseWestern/courseGeneralize.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "DtxChineseWesternTeachingTeam",
          component: () =>
            import("@/views/custom/Dtx_chineseWestern/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--山西徐特立高级职业中学--工业机器人应用与编程
    {
      path: "/custom/Xtl_IndustrialRobot",
      name: "XtlIndustrialRobot",
      component: () => import("@/views/custom/Xtl_IndustrialRobot/layout.vue"),
      redirect: "/custom/Xtl_IndustrialRobot/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "XtlIndustrialRobotHome",
          component: () => import("@/views/custom/Xtl_IndustrialRobot/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "XtlIndustrialRobotLearn",
          component: () =>
            import("@/views/custom/Xtl_IndustrialRobot/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "XtlIndustrialRobotCourseGeneralize",
          component: () =>
            import("@/views/custom/Xtl_IndustrialRobot/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "XtlIndustrialRobotStandard",
          component: () =>
            import("@/views/custom/Xtl_IndustrialRobot/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "XtlIndustrialRobotTeachingTeam",
          component: () =>
            import("@/views/custom/Xtl_IndustrialRobot/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "XtlIndustrialRobotActivityList",
          component: () =>
            import("@/views/custom/Xtl_IndustrialRobot/activityList.vue")
        }
      ]
    },
    // 课程自定义--山西徐特立高级职业中学--工业机器人技术
    {
      path: "/custom/Xtl_RobotTechnology",

      name: "XtlRobotTechnology",
      component: () => import("@/views/custom/Xtl_RobotTechnology/layout.vue"),
      redirect: "/custom/Xtl_RobotTechnology/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "XtlRobotTechnologyHome",
          component: () => import("@/views/custom/Xtl_RobotTechnology/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "XtlRobotTechnologyLearn",
          component: () =>
            import("@/views/custom/Xtl_RobotTechnology/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "XtlRobotTechnologyStandard",
          component: () =>
            import("@/views/custom/Xtl_RobotTechnology/standard.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "XtlRobotTechnologyCourseGeneralize",
          component: () =>
            import("@/views/custom/Xtl_RobotTechnology/courseGeneralize.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "XtlRobotTechnologyTeachingTeam",
          component: () =>
            import("@/views/custom/Xtl_RobotTechnology/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--晋中市太谷区职业中学校--仓储作业实务
    {
      path: "/custom/Tgq_WarehousingPractice",
      name: "TgqWarehousingPractice",
      component: () =>
        import("@/views/custom/Tgq_WarehousingPractice/layout.vue"),
      redirect: "/custom/Xtl_IndustrialRobot/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TgqWarehousingPracticeHome",
          component: () =>
            import("@/views/custom/Tgq_WarehousingPractice/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TgqWarehousingPracticeLearn",
          component: () =>
            import("@/views/custom/Tgq_WarehousingPractice/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "TgqWarehousingPracticeCourseGeneralize",
          component: () =>
            import(
              "@/views/custom/Tgq_WarehousingPractice/courseGeneralize.vue"
            )
        },
        //其他页
        {
          path: "standard",
          name: "TgqWarehousingPracticeStandard",
          component: () =>
            import("@/views/custom/Tgq_WarehousingPractice/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "TgqWarehousingPracticeTeachingTeam",
          component: () =>
            import("@/views/custom/Tgq_WarehousingPractice/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "TgqWarehousingPracticeActivityList",
          component: () =>
            import("@/views/custom/Tgq_WarehousingPractice/activityList.vue")
        }
      ]
    },
    // 课程自定义--晋中市太谷区职业中学校--中式面点制作
    {
      path: "/custom/Tgq_ChinesePastry",
      name: "TgqChinesePastry",
      component: () => import("@/views/custom/Tgq_ChinesePastry/layout.vue"),
      redirect: "/custom/Xtl_IndustrialRobot/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TgqChinesePastryHome",
          component: () => import("@/views/custom/Tgq_ChinesePastry/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TgqChinesePastryLearn",
          component: () => import("@/views/custom/Tgq_ChinesePastry/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "TgqChinesePastryCourseGeneralize",
          component: () =>
            import("@/views/custom/Tgq_ChinesePastry/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "TgqChinesePastryStandard",
          component: () =>
            import("@/views/custom/Tgq_ChinesePastry/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "TgqChinesePastryTeachingTeam",
          component: () =>
            import("@/views/custom/Tgq_ChinesePastry/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "TgqChinesePastryActivityList",
          component: () =>
            import("@/views/custom/Tgq_ChinesePastry/activityList.vue")
        }
      ]
    },
    // 课程自定义--山西铁道职业技术学院--铁路信号基础设备维护
    {
      path: "/custom/Tdzy_Railwaysignal",
      name: "TdzyRailwaysignal",
      component: () => import("@/views/custom/Tdzy_Railwaysignal/layout.vue"),
      redirect: "/custom/Xtl_IndustrialRobot/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TdzyRailwaysignalHome",
          component: () => import("@/views/custom/Tdzy_Railwaysignal/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TdzyRailwaysignalLearn",
          component: () => import("@/views/custom/Tdzy_Railwaysignal/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "TdzyRailwaysignalCourseGeneralize",
          component: () =>
            import("@/views/custom/Tdzy_Railwaysignal/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "TdzyRailwaysignalStandard",
          component: () =>
            import("@/views/custom/Tdzy_Railwaysignal/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "TdzyRailwaysignalTeachingTeam",
          component: () =>
            import("@/views/custom/Tdzy_Railwaysignal/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "TdzyRailwaysignalActivityList",
          component: () =>
            import("@/views/custom/Tdzy_Railwaysignal/activityList.vue")
        }
      ]
    },
    // 课程自定义--赤峰卫生学校--计算机网络技术基础
    {
      path: "/custom/Cf_ComputerNetworks",
      name: "CfComputerNetworks",
      component: () => import("@/views/custom/Cf_ComputerNetworks/layout.vue"),
      redirect: "/custom/Cf_ComputerNetworks/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "CfComputerNetworksHome",
          component: () => import("@/views/custom/Cf_ComputerNetworks/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "CfComputerNetworksLearn",
          component: () =>
            import("@/views/custom/Cf_ComputerNetworks/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "CfComputerNetworksCourseGeneralize",
          component: () =>
            import("@/views/custom/Cf_ComputerNetworks/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "CfComputerNetworksStandard",
          component: () =>
            import("@/views/custom/Cf_ComputerNetworks/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "CfComputerNetworksTeachingTeam",
          component: () =>
            import("@/views/custom/Cf_ComputerNetworks/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "CfComputerNetworksActivityList",
          component: () =>
            import("@/views/custom/Cf_ComputerNetworks/activityList.vue")
        }
      ]
    },

    // 课程自定义--赤峰卫生学校--生理学基础
    {
      path: "/custom/Cf_Physiology",
      name: "CfPhysiology",
      component: () => import("@/views/custom/Cf_Physiology/layout.vue"),
      redirect: "/custom/Cf_Physiology/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "CfPhysiologyHome",
          component: () => import("@/views/custom/Cf_Physiology/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "CfPhysiologyLearn",
          component: () => import("@/views/custom/Cf_Physiology/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "CfPhysiologyCourseGeneralize",
          component: () =>
            import("@/views/custom/Cf_Physiology/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "CfPhysiologyStandard",
          component: () => import("@/views/custom/Cf_Physiology/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "CfPhysiologyTeachingTeam",
          component: () =>
            import("@/views/custom/Cf_Physiology/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "CfPhysiologyActivityList",
          component: () =>
            import("@/views/custom/Cf_Physiology/activityList.vue")
        }
      ]
    },
    // 课程自定义--赤峰卫生学校--Visual Basic程序设计
    {
      path: "/custom/Cf_Programming",
      name: "CfProgramming",
      component: () => import("@/views/custom/Cf_Programming/layout.vue"),
      redirect: "/custom/Cf_Physiology/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "CfProgrammingHome",
          component: () => import("@/views/custom/Cf_Programming/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "CfProgrammingLearn",
          component: () => import("@/views/custom/Cf_Programming/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "CfProgrammingCourseGeneralize",
          component: () =>
            import("@/views/custom/Cf_Programming/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "CfProgrammingStandard",
          component: () => import("@/views/custom/Cf_Programming/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "CfProgrammingTeachingTeam",
          component: () =>
            import("@/views/custom/Cf_Programming/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "CfProgrammingActivityList",
          component: () =>
            import("@/views/custom/Cf_Programming/activityList.vue")
        }
      ]
    },
    // 课程自定义--赤峰卫生学校--解剖学基础
    {
      path: "/custom/Cf_Anatomy",
      name: "CfAnatomy",
      component: () => import("@/views/custom/Cf_Anatomy/layout.vue"),
      redirect: "/custom/Cf_Anatomy/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "CfAnatomyHome",
          component: () => import("@/views/custom/Cf_Anatomy/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "CfAnatomyLearn",
          component: () => import("@/views/custom/Cf_Anatomy/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "CfAnatomyCourseGeneralize",
          component: () =>
            import("@/views/custom/Cf_Anatomy/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "CfAnatomyStandard",
          component: () => import("@/views/custom/Cf_Anatomy/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "CfAnatomyTeachingTeam",
          component: () => import("@/views/custom/Cf_Anatomy/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "CfAnatomyActivityList",
          component: () => import("@/views/custom/Cf_Anatomy/activityList.vue")
        }
      ]
    },
    // 课程自定义--昌都市第二中等职业技术学院--电工电子技术
    {
      path: "/custom/Cds_ElectronicTechnique",
      name: "CdsElectronicTechnique",
      component: () =>
        import("@/views/custom/Cds_ElectronicTechnique/layout.vue"),
      redirect: "/custom/Cds_ElectronicTechnique/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "CdsElectronicTechniqueHome",
          component: () =>
            import("@/views/custom/Cds_ElectronicTechnique/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "CdsElectronicTechniqueLearn",
          component: () =>
            import("@/views/custom/Cds_ElectronicTechnique/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "CdsElectronicTechniqueCourseGeneralize",
          component: () =>
            import(
              "@/views/custom/Cds_ElectronicTechnique/courseGeneralize.vue"
            )
        },
        //其他页
        {
          path: "standard",
          name: "CdsElectronicTechniqueStandard",
          component: () =>
            import("@/views/custom/Cds_ElectronicTechnique/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "CdsElectronicTechniqueTeachingTeam",
          component: () =>
            import("@/views/custom/Cds_ElectronicTechnique/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "CdsElectronicTechniqueActivityList",
          component: () =>
            import("@/views/custom/Cds_ElectronicTechnique/activityList.vue")
        }
      ]
    },
    // 课程自定义--昌都市第二中等职业技术学院--光伏电站运维技术
    {
      path: "/custom/Cds_PhotovoltaicPower",
      name: "CdsPhotovoltaicPower",
      component: () =>
        import("@/views/custom/Cds_PhotovoltaicPower/layout.vue"),
      redirect: "/custom/Cds_PhotovoltaicPower/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "CdsPhotovoltaicPowerHome",
          component: () =>
            import("@/views/custom/Cds_PhotovoltaicPower/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "CdsPhotovoltaicPowerLearn",
          component: () =>
            import("@/views/custom/Cds_PhotovoltaicPower/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "CdsPhotovoltaicPowerCourseGeneralize",
          component: () =>
            import("@/views/custom/Cds_PhotovoltaicPower/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "CdsPhotovoltaicPowerStandard",
          component: () =>
            import("@/views/custom/Cds_PhotovoltaicPower/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "CdsPhotovoltaicPowerTeachingTeam",
          component: () =>
            import("@/views/custom/Cds_PhotovoltaicPower/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "CdsPhotovoltaicPowerActivityList",
          component: () =>
            import("@/views/custom/Cds_PhotovoltaicPower/activityList.vue")
        }
      ]
    },
    // 课程自定义--昌都市第二中等职业技术学院--新能源技术
    {
      path: "/custom/Cds_NewEnergy",
      name: "CdsNewEnergy",
      component: () => import("@/views/custom/Cds_NewEnergy/layout.vue"),
      redirect: "/custom/Cds_NewEnergy/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "CdsNewEnergyHome",
          component: () => import("@/views/custom/Cds_NewEnergy/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "CdsNewEnergyLearn",
          component: () => import("@/views/custom/Cds_NewEnergy/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "CdsNewEnergyCourseGeneralize",
          component: () =>
            import("@/views/custom/Cds_NewEnergy/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "CdsNewEnergyStandard",
          component: () => import("@/views/custom/Cds_NewEnergy/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "CdsNewEnergyTeachingTeam",
          component: () =>
            import("@/views/custom/Cds_NewEnergy/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "CdsNewEnergyActivityList",
          component: () =>
            import("@/views/custom/Cds_NewEnergy/activityList.vue")
        }
      ]
    },
    // 课程自定义--内蒙古电子信息职业技术学院--人力资源管理
    {
      path: "/custom/Nmdz_ManpowerResource",
      name: "NmdzManpowerResource",
      component: () =>
        import("@/views/custom/Nmdz_ManpowerResource/layout.vue"),
      redirect: "/custom/Cds_NewEnergy/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "NmdzManpowerResourceHome",
          component: () =>
            import("@/views/custom/Nmdz_ManpowerResource/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "NmdzManpowerResourceLearn",
          component: () =>
            import("@/views/custom/Nmdz_ManpowerResource/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "NmdzManpowerResourceCourseGeneralize",
          component: () =>
            import("@/views/custom/Nmdz_ManpowerResource/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "NmdzManpowerResourceStandard",
          component: () =>
            import("@/views/custom/Nmdz_ManpowerResource/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "NmdzManpowerResourceTeachingTeam",
          component: () =>
            import("@/views/custom/Nmdz_ManpowerResource/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "NmdzManpowerResourceActivityList",
          component: () =>
            import("@/views/custom/Nmdz_ManpowerResource/activityList.vue")
        }
      ]
    },
    // 课程自定义--太原市交通学校--汽车发动机构造与拆装
    {
      path: "/custom/Tys_automobileEngine",
      name: "TysAutomobileEngine",
      component: () => import("@/views/custom/Tys_automobileEngine/layout.vue"),
      redirect: "/custom/Tys_automobileEngine/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TysAutomobileEngineHome",
          component: () =>
            import("@/views/custom/Tys_automobileEngine/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TysAutomobileEngineLearn",
          component: () =>
            import("@/views/custom/Tys_automobileEngine/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "TysAutomobileEngineCourseGeneralize",
          component: () =>
            import("@/views/custom/Tys_automobileEngine/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "TysAutomobileEngineStandard",
          component: () =>
            import("@/views/custom/Tys_automobileEngine/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "TysAutomobileEngineTeachingTeam",
          component: () =>
            import("@/views/custom/Tys_automobileEngine/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "TysAutomobileEngineActivityList",
          component: () =>
            import("@/views/custom/Tys_automobileEngine/activityList.vue")
        }
      ]
    },
    // 课程自定义--太原市财政金融学校--金融销售
    {
      path: "/custom/Czjr_FinancialSales",
      name: "CzjrFinancialSales",
      component: () => import("@/views/custom/Czjr_FinancialSales/layout.vue"),
      redirect: "/custom/Czjr_FinancialSales/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "CzjrFinancialSalesHome",
          component: () => import("@/views/custom/Czjr_FinancialSales/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "CzjrFinancialSalesLearn",
          component: () =>
            import("@/views/custom/Czjr_FinancialSales/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "CzjrFinancialSalesCourseGeneralize",
          component: () =>
            import("@/views/custom/Czjr_FinancialSales/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "CzjrFinancialSalesStandard",
          component: () =>
            import("@/views/custom/Czjr_FinancialSales/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "CzjrFinancialSalesTeachingTeam",
          component: () =>
            import("@/views/custom/Czjr_FinancialSales/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--太原市财政金融学校--电子银行业务
    {
      path: "/custom/Czjr_ElectronicBanking",
      name: "CzjrElectronicBanking",
      component: () =>
        import("@/views/custom/Czjr_ElectronicBanking/layout.vue"),
      redirect: "/custom/Czjr_ElectronicBanking/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "CzjrElectronicBankingHome",
          component: () =>
            import("@/views/custom/Czjr_ElectronicBanking/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "CzjrElectronicBankingLearn",
          component: () =>
            import("@/views/custom/Czjr_ElectronicBanking/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "CzjrElectronicBankingCourseGeneralize",
          component: () =>
            import("@/views/custom/Czjr_ElectronicBanking/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "CzjrElectronicBankingStandard",
          component: () =>
            import("@/views/custom/Czjr_ElectronicBanking/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "CzjrElectronicBankingTeachingTeam",
          component: () =>
            import("@/views/custom/Czjr_ElectronicBanking/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--太原市财政金融学校--心理健康与职业生涯
    {
      path: "/custom/Czjr_MentalHealth",
      name: "CzjrMentalHealth",
      component: () => import("@/views/custom/Czjr_MentalHealth/layout.vue"),
      redirect: "/custom/Czjr_MentalHealth/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "CzjrMentalHealthHome",
          component: () => import("@/views/custom/Czjr_MentalHealth/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "CzjrMentalHealthLearn",
          component: () => import("@/views/custom/Czjr_MentalHealth/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "CzjrMentalHealthCourseGeneralize",
          component: () =>
            import("@/views/custom/Czjr_MentalHealth/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "CzjrMentalHealthStandard",
          component: () =>
            import("@/views/custom/Czjr_MentalHealth/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "CzjrMentalHealthTeachingTeam",
          component: () =>
            import("@/views/custom/Czjr_MentalHealth/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--太原市财政金融学校--服饰造型
    {
      path: "/custom/Czjr_ClothingModeling",
      name: "CzjrClothingModeling",
      component: () =>
        import("@/views/custom/Czjr_ClothingModeling/layout.vue"),
      redirect: "/custom/Czjr_ClothingModeling/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "CzjrClothingModelingHome",
          component: () =>
            import("@/views/custom/Czjr_ClothingModeling/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "CzjrClothingModelingLearn",
          component: () =>
            import("@/views/custom/Czjr_ClothingModeling/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "CzjrClothingModelingCourseGeneralize",
          component: () =>
            import("@/views/custom/Czjr_ClothingModeling/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "CzjrClothingModelingStandard",
          component: () =>
            import("@/views/custom/Czjr_ClothingModeling/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "CzjrClothingModelingTeachingTeam",
          component: () =>
            import("@/views/custom/Czjr_ClothingModeling/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--太原市财政金融学校--哲学与人生
    {
      path: "/custom/Czjr_PhilosophyLife",
      name: "CzjrPhilosophyLife",
      component: () => import("@/views/custom/Czjr_PhilosophyLife/layout.vue"),
      redirect: "/custom/Czjr_PhilosophyLife/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "CzjrPhilosophyLifeHome",
          component: () => import("@/views/custom/Czjr_PhilosophyLife/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "CzjrPhilosophyLifeLearn",
          component: () =>
            import("@/views/custom/Czjr_PhilosophyLife/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "CzjrPhilosophyLifeCourseGeneralize",
          component: () =>
            import("@/views/custom/Czjr_PhilosophyLife/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "CzjrPhilosophyLifeStandard",
          component: () =>
            import("@/views/custom/Czjr_PhilosophyLife/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "CzjrPhilosophyLifeTeachingTeam",
          component: () =>
            import("@/views/custom/Czjr_PhilosophyLife/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--太原市财政金融学校--正常人体结构
    {
      path: "/custom/Czjr_BodyStructure",
      name: "CzjrBodyStructure",
      component: () => import("@/views/custom/Czjr_BodyStructure/layout.vue"),
      redirect: "/custom/Czjr_BodyStructure/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "CzjrBodyStructureHome",
          component: () => import("@/views/custom/Czjr_BodyStructure/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "CzjrBodyStructureLearn",
          component: () => import("@/views/custom/Czjr_BodyStructure/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "CzjrBodyStructureCourseGeneralize",
          component: () =>
            import("@/views/custom/Czjr_BodyStructure/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "CzjrBodyStructureStandard",
          component: () =>
            import("@/views/custom/Czjr_BodyStructure/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "CzjrBodyStructureTeachingTeam",
          component: () =>
            import("@/views/custom/Czjr_BodyStructure/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--太原市财政金融学校--美容化妆基础
    {
      path: "/custom/Czjr_Hairdressing",
      name: "CzjrHairdressing",
      component: () => import("@/views/custom/Czjr_Hairdressing/layout.vue"),
      redirect: "/custom/Czjr_Hairdressing/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "CzjrHairdressingHome",
          component: () => import("@/views/custom/Czjr_Hairdressing/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "CzjrHairdressingLearn",
          component: () => import("@/views/custom/Czjr_Hairdressing/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "CzjrHairdressingCourseGeneralize",
          component: () =>
            import("@/views/custom/Czjr_Hairdressing/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "CzjrHairdressingStandard",
          component: () =>
            import("@/views/custom/Czjr_Hairdressing/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "CzjrHairdressingTeachingTeam",
          component: () =>
            import("@/views/custom/Czjr_Hairdressing/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--太原市财政金融学校--互联网金融
    {
      path: "/custom/Czjr_OnlineFinance",
      name: "CzjrOnlineFinance",
      component: () => import("@/views/custom/Czjr_OnlineFinance/layout.vue"),
      redirect: "/custom/Czjr_OnlineFinance/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "CzjrOnlineFinanceHome",
          component: () => import("@/views/custom/Czjr_OnlineFinance/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "CzjrOnlineFinanceLearn",
          component: () => import("@/views/custom/Czjr_OnlineFinance/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "CzjrOnlineFinanceCourseGeneralize",
          component: () =>
            import("@/views/custom/Czjr_OnlineFinance/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "CzjrOnlineFinanceStandard",
          component: () =>
            import("@/views/custom/Czjr_OnlineFinance/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "CzjrOnlineFinanceTeachingTeam",
          component: () =>
            import("@/views/custom/Czjr_OnlineFinance/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--山西省工业管理学校--Web前端开发
    {
      path: "/custom/Gygl_WebDevelop",
      name: "GyglWebDevelop",
      component: () => import("@/views/custom/Gygl_WebDevelop/layout.vue"),
      redirect: "/custom/Gygl_WebDevelop/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "GyglWebDevelopHome",
          component: () => import("@/views/custom/Gygl_WebDevelop/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "GyglWebDevelopLearn",
          component: () => import("@/views/custom/Gygl_WebDevelop/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "GyglWebDevelopCourseGeneralize",
          component: () =>
            import("@/views/custom/Gygl_WebDevelop/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "GyglWebDevelopStandard",
          component: () => import("@/views/custom/Gygl_WebDevelop/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "GyglWebDevelopTeachingTeam",
          component: () =>
            import("@/views/custom/Gygl_WebDevelop/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--平乡县职业技术教育中心--自行车训练与指导
    {
      path: "/custom/Pxx_TrainingInstruction",
      name: "PxxTrainingInstruction",
      component: () =>
        import("@/views/custom/Pxx_TrainingInstruction/layout.vue"),
      redirect: "/custom/Pxx_TrainingInstruction/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "PxxTrainingInstructionHome",
          component: () =>
            import("@/views/custom/Pxx_TrainingInstruction/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "PxxTrainingInstructionLearn",
          component: () =>
            import("@/views/custom/Pxx_TrainingInstruction/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "PxxTrainingInstructionCourseGeneralize",
          component: () =>
            import(
              "@/views/custom/Pxx_TrainingInstruction/courseGeneralize.vue"
            )
        },
        //其他页
        {
          path: "standard",
          name: "PxxTrainingInstructionStandard",
          component: () =>
            import("@/views/custom/Pxx_TrainingInstruction/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "PxxTrainingInstructionTeachingTeam",
          component: () =>
            import("@/views/custom/Pxx_TrainingInstruction/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "PxxTrainingInstructionActivityList",
          component: () =>
            import("@/views/custom/Pxx_TrainingInstruction/activityList.vue")
        }
      ]
    },
    // 课程自定义--平乡县职业技术教育中心--python程序编写入门
    {
      path: "/custom/Pxx_PyProcedure",
      name: "PxxPyProcedure",
      component: () => import("@/views/custom/Pxx_PyProcedure/layout.vue"),
      redirect: "/custom/Pxx_PyProcedure/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "PxxPyProcedureHome",
          component: () => import("@/views/custom/Pxx_PyProcedure/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "PxxPyProcedureLearn",
          component: () => import("@/views/custom/Pxx_PyProcedure/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "PxxPyProcedureCourseGeneralize",
          component: () =>
            import("@/views/custom/Pxx_PyProcedure/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "PxxPyProcedureStandard",
          component: () => import("@/views/custom/Pxx_PyProcedure/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "PxxPyProcedureTeachingTeam",
          component: () =>
            import("@/views/custom/Pxx_PyProcedure/teachingTeam.vue")
        },
        //活动列表
        {
          path: "activityList",
          name: "PxxPyProcedureActivityList",
          component: () =>
            import("@/views/custom/Pxx_PyProcedure/activityList.vue")
        }
      ]
    },
    // 课程自定义--太原市卫生学校--护理学基础
    {
      path: "/custom/Tyws_BasicNursing",
      name: "TywsBasicNursing",
      component: () => import("@/views/custom/Tyws_BasicNursing/layout.vue"),
      redirect: "/custom/Tyws_BasicNursing/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "TywsBasicNursingHome",
          component: () => import("@/views/custom/Tyws_BasicNursing/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "TywsBasicNursingLearn",
          component: () => import("@/views/custom/Tyws_BasicNursing/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "TywsBasicNursingCourseGeneralize",
          component: () =>
            import("@/views/custom/Tyws_BasicNursing/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "TywsBasicNursingStandard",
          component: () =>
            import("@/views/custom/Tyws_BasicNursing/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "TywsBasicNursingTeachingTeam",
          component: () =>
            import("@/views/custom/Tyws_BasicNursing/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--果洛州职业技术学校--酒店公共关系
    {
      path: "/custom/Glz_HotelPublic",
      name: "GlzHotelPublic",
      component: () => import("@/views/custom/Glz_HotelPublic/layout.vue"),
      redirect: "/custom/Glz_HotelPublic/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "GlzHotelPublicHome",
          component: () => import("@/views/custom/Glz_HotelPublic/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "GlzHotelPublicLearn",
          component: () => import("@/views/custom/Glz_HotelPublic/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "GlzHotelPublicCourseGeneralize",
          component: () =>
            import("@/views/custom/Glz_HotelPublic/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "GlzHotelPublicStandard",
          component: () => import("@/views/custom/Glz_HotelPublic/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "GlzHotelPublicTeachingTeam",
          component: () =>
            import("@/views/custom/Glz_HotelPublic/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--果洛州职业技术学校--茶艺实训
    {
      path: "/custom/Glz_TeaTraining",
      name: "GlzTeaTraining",
      component: () => import("@/views/custom/Glz_TeaTraining/layout.vue"),
      redirect: "/custom/Glz_TeaTraining/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "GlzTeaTrainingHome",
          component: () => import("@/views/custom/Glz_TeaTraining/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "GlzTeaTrainingLearn",
          component: () => import("@/views/custom/Glz_TeaTraining/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "GlzTeaTrainingCourseGeneralize",
          component: () =>
            import("@/views/custom/Glz_TeaTraining/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "GlzTeaTrainingStandard",
          component: () => import("@/views/custom/Glz_TeaTraining/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "GlzTeaTrainingTeachingTeam",
          component: () =>
            import("@/views/custom/Glz_TeaTraining/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--大通县职业技术学校--热菜制作
    {
      path: "/custom/Dtx_DishMaking",
      name: "DtxDishMaking",
      component: () => import("@/views/custom/Dtx_DishMaking/layout.vue"),
      redirect: "/custom/Dtx_DishMaking/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "DtxDishMakingHome",
          component: () => import("@/views/custom/Dtx_DishMaking/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "DtxDishMakingLearn",
          component: () => import("@/views/custom/Dtx_DishMaking/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "DtxDishMakingCourseGeneralize",
          component: () =>
            import("@/views/custom/Dtx_DishMaking/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "DtxDishMakingStandard",
          component: () => import("@/views/custom/Dtx_DishMaking/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "DtxDishMakingTeachingTeam",
          component: () =>
            import("@/views/custom/Dtx_DishMaking/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--伽师县中等职业技术学校--中式面点
    {
      path: "/custom/Jsx_ChinesePastry",
      name: "JsxChinesePastry",
      component: () => import("@/views/custom/Jsx_ChinesePastry/layout.vue"),
      redirect: "/custom/Jsx_ChinesePastry/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "JsxChinesePastryHome",
          component: () => import("@/views/custom/Jsx_ChinesePastry/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "JsxChinesePastryLearn",
          component: () => import("@/views/custom/Jsx_ChinesePastry/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "JsxChinesePastryCourseGeneralize",
          component: () =>
            import("@/views/custom/Jsx_ChinesePastry/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "JsxChinesePastryStandard",
          component: () =>
            import("@/views/custom/Jsx_ChinesePastry/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "JsxChinesePastryTeachingTeam",
          component: () =>
            import("@/views/custom/Jsx_ChinesePastry/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--伽师县中等职业技术学校--中餐烹饪
    {
      path: "/custom/Jsx_CuisineCooking",
      name: "JsxCuisineCooking",
      component: () => import("@/views/custom/Jsx_CuisineCooking/layout.vue"),
      redirect: "/custom/Jsx_CuisineCooking/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "JsxCuisineCookingHome",
          component: () => import("@/views/custom/Jsx_CuisineCooking/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "JsxCuisineCookingLearn",
          component: () => import("@/views/custom/Jsx_CuisineCooking/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "JsxCuisineCookingCourseGeneralize",
          component: () =>
            import("@/views/custom/Jsx_CuisineCooking/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "JsxCuisineCookingStandard",
          component: () =>
            import("@/views/custom/Jsx_CuisineCooking/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "JsxCuisineCookingTeachingTeam",
          component: () =>
            import("@/views/custom/Jsx_CuisineCooking/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--伽师县中等职业技术学校--建筑施工技术
    {
      path: "/custom/Jsx_BuildingOperations",
      name: "JsxBuildingOperations",
      component: () =>
        import("@/views/custom/Jsx_BuildingOperations/layout.vue"),
      redirect: "/custom/Jsx_BuildingOperations/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "JsxBuildingOperationsHome",
          component: () =>
            import("@/views/custom/Jsx_BuildingOperations/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "JsxBuildingOperationsLearn",
          component: () =>
            import("@/views/custom/Jsx_BuildingOperations/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "JsxBuildingOperationsCourseGeneralize",
          component: () =>
            import("@/views/custom/Jsx_BuildingOperations/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "JsxBuildingOperationsStandard",
          component: () =>
            import("@/views/custom/Jsx_BuildingOperations/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "JsxBuildingOperationsTeachingTeam",
          component: () =>
            import("@/views/custom/Jsx_BuildingOperations/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--伽师县中等职业技术学校--建筑施工测量
    {
      path: "/custom/Jsx_ConstructionSurveying",
      name: "JsxConstructionSurveying",
      component: () =>
        import("@/views/custom/Jsx_ConstructionSurveying/layout.vue"),
      redirect: "/custom/Jsx_ConstructionSurveying/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "JsxConstructionSurveyingHome",
          component: () =>
            import("@/views/custom/Jsx_ConstructionSurveying/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "JsxConstructionSurveyingLearn",
          component: () =>
            import("@/views/custom/Jsx_ConstructionSurveying/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "JsxConstructionSurveyingCourseGeneralize",
          component: () =>
            import(
              "@/views/custom/Jsx_ConstructionSurveying/courseGeneralize.vue"
            )
        },
        //其他页
        {
          path: "standard",
          name: "JsxConstructionSurveyingStandard",
          component: () =>
            import("@/views/custom/Jsx_ConstructionSurveying/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "JsxConstructionSurveyingTeachingTeam",
          component: () =>
            import("@/views/custom/Jsx_ConstructionSurveying/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--昌都市职业技术学校--畜牧学概论
    {
      path: "/custom/Cds_ZootechnicalScience",
      name: "CdsZootechnicalScience",
      component: () =>
        import("@/views/custom/Cds_ZootechnicalScience/layout.vue"),
      redirect: "/custom/Cds_ZootechnicalScience/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "CdsZootechnicalScienceHome",
          component: () =>
            import("@/views/custom/Cds_ZootechnicalScience/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "CdsZootechnicalScienceLearn",
          component: () =>
            import("@/views/custom/Cds_ZootechnicalScience/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "CdsZootechnicalScienceCourseGeneralize",
          component: () =>
            import(
              "@/views/custom/Cds_ZootechnicalScience/courseGeneralize.vue"
            )
        },
        //其他页
        {
          path: "standard",
          name: "CdsZootechnicalScienceStandard",
          component: () =>
            import("@/views/custom/Cds_ZootechnicalScience/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "CdsZootechnicalScienceTeachingTeam",
          component: () =>
            import("@/views/custom/Cds_ZootechnicalScience/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--昌都市职业技术学校--社会文化艺术
    {
      path: "/custom/Cds_SocialCulture",
      name: "CdsSocialCulture",
      component: () => import("@/views/custom/Cds_SocialCulture/layout.vue"),
      redirect: "/custom/Cds_SocialCulture/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "CdsSocialCultureHome",
          component: () => import("@/views/custom/Cds_SocialCulture/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "CdsSocialCultureLearn",
          component: () => import("@/views/custom/Cds_SocialCulture/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "CdsSocialCultureCourseGeneralize",
          component: () =>
            import("@/views/custom/Cds_SocialCulture/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "CdsSocialCultureStandard",
          component: () =>
            import("@/views/custom/Cds_SocialCulture/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "CdsSocialCultureTeachingTeam",
          component: () =>
            import("@/views/custom/Cds_SocialCulture/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--朔城区神头职业中学校--图形图像处理
    {
      path: "/custom/St_GraphicImage",
      name: "StGraphicImage",
      component: () => import("@/views/custom/St_GraphicImage/layout.vue"),
      redirect: "/custom/St_GraphicImage/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "StGraphicImageHome",
          component: () => import("@/views/custom/St_GraphicImage/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "StGraphicImageLearn",
          component: () => import("@/views/custom/St_GraphicImage/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "StGraphicImageCourseGeneralize",
          component: () =>
            import("@/views/custom/St_GraphicImage/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "StGraphicImageStandard",
          component: () => import("@/views/custom/St_GraphicImage/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "StGraphicImageTeachingTeam",
          component: () =>
            import("@/views/custom/St_GraphicImage/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--朔城区神头职业中学校--电子商务基础
    {
      path: "/custom/St_ElectronicCommerce",
      name: "StElectronicCommerce",
      component: () =>
        import("@/views/custom/St_ElectronicCommerce/layout.vue"),
      redirect: "/custom/St_ElectronicCommerce/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "StElectronicCommerceHome",
          component: () =>
            import("@/views/custom/St_ElectronicCommerce/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "StElectronicCommerceLearn",
          component: () =>
            import("@/views/custom/St_ElectronicCommerce/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "StElectronicCommerceCourseGeneralize",
          component: () =>
            import("@/views/custom/St_ElectronicCommerce/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "StElectronicCommerceStandard",
          component: () =>
            import("@/views/custom/St_ElectronicCommerce/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "StElectronicCommerceTeachingTeam",
          component: () =>
            import("@/views/custom/St_ElectronicCommerce/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--朔城区神头职业中学校--计算机网络基础
    {
      path: "/custom/St_ComputerNetworks",
      name: "StComputerNetworks",
      component: () => import("@/views/custom/St_ComputerNetworks/layout.vue"),
      redirect: "/custom/St_ComputerNetworks/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "StComputerNetworksHome",
          component: () => import("@/views/custom/St_ComputerNetworks/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "StComputerNetworksLearn",
          component: () =>
            import("@/views/custom/St_ComputerNetworks/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "StComputerNetworksCourseGeneralize",
          component: () =>
            import("@/views/custom/St_ComputerNetworks/courseGeneralize.vue")
        },
        //其他页
        {
          path: "standard",
          name: "StComputerNetworksStandard",
          component: () =>
            import("@/views/custom/St_ComputerNetworks/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "StComputerNetworksTeachingTeam",
          component: () =>
            import("@/views/custom/St_ComputerNetworks/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--北镇市中等职业技术专业学校--汽车运用与维修
    {
      path: "/custom/Bzs_AutomobileOperation",
      name: "BzsAutomobileOperation",
      component: () =>
        import("@/views/custom/Bzs_AutomobileOperation/layout.vue"),
      redirect: "/custom/Bzs_AutomobileOperation/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "BzsAutomobileOperationHome",
          component: () =>
            import("@/views/custom/Bzs_AutomobileOperation/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "BzsAutomobileOperationLearn",
          component: () =>
            import("@/views/custom/Bzs_AutomobileOperation/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "BzsAutomobileOperationCourseGeneralize",
          component: () =>
            import(
              "@/views/custom/Bzs_AutomobileOperation/courseGeneralize.vue"
            )
        },
        //其他页
        {
          path: "standard",
          name: "BzsAutomobileOperationStandard",
          component: () =>
            import("@/views/custom/Bzs_AutomobileOperation/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "BzsAutomobileOperationTeachingTeam",
          component: () =>
            import("@/views/custom/Bzs_AutomobileOperation/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--北镇市中等职业技术专业学校--计算机应用专业
    {
      path: "/custom/Bzs_ComputerApplication",
      name: "BzsComputerApplication",
      component: () =>
        import("@/views/custom/Bzs_ComputerApplication/layout.vue"),
      redirect: "/custom/Bzs_ComputerApplication/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "BzsComputerApplicationHome",
          component: () =>
            import("@/views/custom/Bzs_ComputerApplication/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "BzsComputerApplicationLearn",
          component: () =>
            import("@/views/custom/Bzs_ComputerApplication/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "BzsComputerApplicationCourseGeneralize",
          component: () =>
            import(
              "@/views/custom/Bzs_ComputerApplication/courseGeneralize.vue"
            )
        },
        //其他页
        {
          path: "standard",
          name: "BzsComputerApplicationStandard",
          component: () =>
            import("@/views/custom/Bzs_ComputerApplication/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "BzsComputerApplicationTeachingTeam",
          component: () =>
            import("@/views/custom/Bzs_ComputerApplication/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--北镇市中等职业技术专业学校--机械加工技术
    {
      path: "/custom/Bzs_MachiningTechnology",
      name: "BzsMachiningTechnology",
      component: () =>
        import("@/views/custom/Bzs_MachiningTechnology/layout.vue"),
      redirect: "/custom/Bzs_MachiningTechnology/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "BzsMachiningTechnologyHome",
          component: () =>
            import("@/views/custom/Bzs_MachiningTechnology/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "BzsMachiningTechnologyLearn",
          component: () =>
            import("@/views/custom/Bzs_MachiningTechnology/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "BzsMachiningTechnologyCourseGeneralize",
          component: () =>
            import(
              "@/views/custom/Bzs_MachiningTechnology/courseGeneralize.vue"
            )
        },
        //其他页
        {
          path: "standard",
          name: "BzsMachiningTechnologyStandard",
          component: () =>
            import("@/views/custom/Bzs_MachiningTechnology/standard.vue")
        },
        //教学团队
        {
          path: "teachingTeam",
          name: "BzsMachiningTechnologyTeachingTeam",
          component: () =>
            import("@/views/custom/Bzs_MachiningTechnology/teachingTeam.vue")
        }
      ]
    },
    // 课程自定义--乌拉特前旗职业中等专业学校--幼儿语言与活动指导
    {
      path: "/custom/Wlt_ChildLanguage",
      name: "WltChildLanguage",
      component: () =>
        import("@/views/custom/Wlt_ChildLanguage/layout.vue"),
      redirect: "/custom/Wlt_ChildLanguage/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "WltChildLanguageHome",
          component: () =>
            import("@/views/custom/Wlt_ChildLanguage/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "WltChildLanguageLearn",
          component: () =>
            import("@/views/custom/Wlt_ChildLanguage/learn.vue")
        },
        //课程概况
        {
          path: "courseGeneralize",
          name: "WltChildLanguageCourseGeneralize",
          component: () =>
            import(
              "@/views/custom/Wlt_ChildLanguage/courseGeneralize.vue"
            )
        },
        //其他页
        {
          path: "standard",
          name: "WltChildLanguageStandard",
          component: () =>
            import("@/views/custom/Wlt_ChildLanguage/standard.vue")
        },
      ]
    },
    // 课程自定义--乌拉特前旗职业中等专业学校--基础护理
    {
      path: "/custom/Wlt_BasicNursing",
      name: "WltBasicNursing",
      component: () => import("@/views/custom/Wlt_BasicNursing/layout.vue"),
      redirect: "/custom/Wlt_BasicNursing/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "WltBasicNursingHome",
          component: () =>
            import("@/views/custom/Wlt_BasicNursing/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "WltBasicNursingLearn",
          component: () =>
            import("@/views/custom/Wlt_BasicNursing/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "WltBasicNursingStandard",
          component: () =>
            import("@/views/custom/Wlt_BasicNursing/standard.vue")
        },
      ]
    },
    // 课程自定义--兴安职业技术学院--养羊与羊病防治
    {
      path: "/custom/Xa_SheepRaising",
      name: "XaSheepRaising",
      component: () =>
        import("@/views/custom/Xa_SheepRaising/layout.vue"),
      redirect: "/custom/Xa_SheepRaising/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "XaSheepRaisingHome",
          component: () =>
            import("@/views/custom/Xa_SheepRaising/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "XaSheepRaisingLearn",
          component: () =>
            import("@/views/custom/Xa_SheepRaising/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "XaSheepRaisingStandard",
          component: () =>
            import("@/views/custom/Xa_SheepRaising/standard.vue")
        },
      ]
    },
    // 课程自定义--兴安职业技术学院--园艺作物生产技术（四）花卉生产
    {
      path: "/custom/Xa_FlowerProduction",
      name: "XaFlowerProduction",
      component: () =>
        import("@/views/custom/Xa_FlowerProduction/layout.vue"),
      redirect: "/custom/Xa_FlowerProduction/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "XaFlowerProductionHome",
          component: () =>
            import("@/views/custom/Xa_FlowerProduction/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "XaFlowerProductionLearn",
          component: () =>
            import("@/views/custom/Xa_FlowerProduction/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "XaFlowerProductionStandard",
          component: () =>
            import("@/views/custom/Xa_FlowerProduction/standard.vue")
        },
      ]
    },
    // 课程自定义--兴安职业技术学院--农作物生产技术
    {
      path: "/custom/Xa_CropProduction",
      name: "XaCropProduction",
      component: () =>
        import("@/views/custom/Xa_CropProduction/layout.vue"),
      redirect: "/custom/Xa_CropProduction/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "XaCropProductionHome",
          component: () =>
            import("@/views/custom/Xa_CropProduction/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "XaCropProductionLearn",
          component: () =>
            import("@/views/custom/Xa_CropProduction/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "XaCropProductionStandard",
          component: () =>
            import("@/views/custom/Xa_CropProduction/standard.vue")
        },
      ]
    },
    // 课程自定义--兴安职业技术学院--农产品质量检测技术
    {
      path: "/custom/Xa_FarmProducts",
      name: "XaFarmProducts",
      component: () =>
        import("@/views/custom/Xa_FarmProducts/layout.vue"),
      redirect: "/custom/Xa_FarmProducts/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "XaFarmProductsHome",
          component: () =>
            import("@/views/custom/Xa_FarmProducts/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "XaFarmProductsLearn",
          component: () =>
            import("@/views/custom/Xa_FarmProducts/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "XaFarmProductsStandard",
          component: () =>
            import("@/views/custom/Xa_FarmProducts/standard.vue")
        },
      ]
    },
    // 课程自定义--兴安职业技术学院--学前儿童健康教育
    {
      path: "/custom/Xa_PreprimaryChildren",
      name: "XaPreprimaryChildren",
      component: () =>
        import("@/views/custom/Xa_PreprimaryChildren/layout.vue"),
      redirect: "/custom/Xa_PreprimaryChildren/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "XaPreprimaryChildrenHome",
          component: () =>
            import("@/views/custom/Xa_PreprimaryChildren/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "XaPreprimaryChildrenLearn",
          component: () =>
            import("@/views/custom/Xa_PreprimaryChildren/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "XaPreprimaryChildrenStandard",
          component: () =>
            import("@/views/custom/Xa_PreprimaryChildren/standard.vue")
        },
      ]
    },
    // 课程自定义--兴安职业技术学院--幼儿班级管理
    {
      path: "/custom/Xa_ClassManagement",
      name: "XaClassManagement",
      component: () =>
        import("@/views/custom/Xa_ClassManagement/layout.vue"),
      redirect: "/custom/Xa_ClassManagement/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "XaClassManagementHome",
          component: () =>
            import("@/views/custom/Xa_ClassManagement/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "XaClassManagementLearn",
          component: () =>
            import("@/views/custom/Xa_ClassManagement/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "XaClassManagementStandard",
          component: () =>
            import("@/views/custom/Xa_ClassManagement/standard.vue")
        },
      ]
    },
    // 课程自定义--兴安职业技术学院--学前儿童科学教育
    {
      path: "/custom/Xa_ScientificEducation",
      name: "XaScientificEducation",
      component: () =>
        import("@/views/custom/Xa_ScientificEducation/layout.vue"),
      redirect: "/custom/Xa_ScientificEducation/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "XaScientificEducationHome",
          component: () =>
            import("@/views/custom/Xa_ScientificEducation/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "XaScientificEducationLearn",
          component: () =>
            import("@/views/custom/Xa_ScientificEducation/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "XaScientificEducationStandard",
          component: () =>
            import("@/views/custom/Xa_ScientificEducation/standard.vue")
        },
      ]
    },
    // 课程自定义--兴安职业技术学院--学前儿童行为观察与指导
    {
      path: "/custom/Xa_BehaviorObservation",
      name: "XaBehaviorObservation",
      component: () =>
        import("@/views/custom/Xa_BehaviorObservation/layout.vue"),
      redirect: "/custom/Xa_BehaviorObservation/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "XaBehaviorObservationHome",
          component: () =>
            import("@/views/custom/Xa_BehaviorObservation/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "XaBehaviorObservationLearn",
          component: () =>
            import("@/views/custom/Xa_BehaviorObservation/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "XaBehaviorObservationStandard",
          component: () =>
            import("@/views/custom/Xa_BehaviorObservation/standard.vue")
        },
      ]
    },
    // 课程自定义--兴安职业技术学院--建筑消防设施维护与保养
    {
      path: "/custom/Xa_FireFighting",
      name: "XaFireFighting",
      component: () =>
        import("@/views/custom/Xa_FireFighting/layout.vue"),
      redirect: "/custom/Xa_FireFighting/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "XaFireFightingHome",
          component: () =>
            import("@/views/custom/Xa_FireFighting/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "XaFireFightingLearn",
          component: () =>
            import("@/views/custom/Xa_FireFighting/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "XaFireFightingStandard",
          component: () =>
            import("@/views/custom/Xa_FireFighting/standard.vue")
        },
      ]
    },
    // 课程自定义--兴安职业技术学院--外科护理
    {
      path: "/custom/Xa_SurgicalNursing",
      name: "XaSurgicalNursing",
      component: () =>
        import("@/views/custom/Xa_SurgicalNursing/layout.vue"),
      redirect: "/custom/Xa_SurgicalNursing/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "XaSurgicalNursingHome",
          component: () =>
            import("@/views/custom/Xa_SurgicalNursing/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "XaSurgicalNursingLearn",
          component: () =>
            import("@/views/custom/Xa_SurgicalNursing/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "XaSurgicalNursingStandard",
          component: () =>
            import("@/views/custom/Xa_SurgicalNursing/standard.vue")
        },
      ]
    },
    // 课程自定义--赤峰第一职业中等专业学校--中式面点技艺
    {
      path: "/custom/Cf_ChinesePastries",
      name: "CfChinesePastries",
      component: () =>
        import("@/views/custom/Cf_ChinesePastries/layout.vue"),
      redirect: "/custom/Cf_ChinesePastries/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "CfChinesePastriesHome",
          component: () =>
            import("@/views/custom/Cf_ChinesePastries/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "CfChinesePastriesLearn",
          component: () =>
            import("@/views/custom/Cf_ChinesePastries/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "CfChinesePastriesStandard",
          component: () =>
            import("@/views/custom/Cf_ChinesePastries/standard.vue")
        },
      ]
    },
    // 课程自定义--赤峰第一职业中等专业学校--高级办公应用项目教程
    {
      path: "/custom/Cf_OfficeApplication",
      name: "CfOfficeApplication",
      component: () =>
        import("@/views/custom/Cf_OfficeApplication/layout.vue"),
      redirect: "/custom/Cf_OfficeApplication/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "CfOfficeApplicationHome",
          component: () =>
            import("@/views/custom/Cf_OfficeApplication/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "CfOfficeApplicationLearn",
          component: () =>
            import("@/views/custom/Cf_OfficeApplication/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "CfOfficeApplicationStandard",
          component: () =>
            import("@/views/custom/Cf_OfficeApplication/standard.vue")
        },
      ]
    },
    
    // 课程自定义--赤峰第一职业中等专业学校--幼儿早期学习支持
    {
      path: "/custom/Cf_EarlyLearning",
      name: "CfEarlyLearning",
      component: () =>
        import("@/views/custom/Cf_EarlyLearning/layout.vue"),
      redirect: "/custom/Cf_EarlyLearning/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "CfEarlyLearningHome",
          component: () =>
            import("@/views/custom/Cf_EarlyLearning/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "CfEarlyLearningLearn",
          component: () =>
            import("@/views/custom/Cf_EarlyLearning/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "CfEarlyLearningStandard",
          component: () =>
            import("@/views/custom/Cf_EarlyLearning/standard.vue")
        },
      ]
    },
    // 课程自定义--杭锦后旗职业教育中心--心理健康与职业生涯
    {
      path: "/custom/Hjhq_MentalHealth",
      name: "HjhqMentalHealth",
      component: () =>
        import("@/views/custom/Hjhq_MentalHealth/layout.vue"),
      redirect: "/custom/Hjhq_MentalHealth/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "HjhqMentalHealthHome",
          component: () =>
            import("@/views/custom/Hjhq_MentalHealth/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "HjhqMentalHealthLearn",
          component: () =>
            import("@/views/custom/Hjhq_MentalHealth/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "HjhqMentalHealthStandard",
          component: () =>
            import("@/views/custom/Hjhq_MentalHealth/standard.vue")
        },
      ]
    },
    // 课程自定义--内蒙古电子信息职业技术学院--心理健康与职业生涯
    {
      path: "/custom/Nmg_LabourEducation",
      name: "NmgLabourEducation",
      component: () =>
        import("@/views/custom/Nmg_LabourEducation/layout.vue"),
      redirect: "/custom/Nmg_LabourEducation/home",
      children: [
        //课程首页
        {
          path: "home",
          name: "NmgLabourEducationHome",
          component: () =>
            import("@/views/custom/Nmg_LabourEducation/home.vue")
        },
        //课程学习
        {
          path: "learn",
          name: "NmgLabourEducationLearn",
          component: () =>
            import("@/views/custom/Nmg_LabourEducation/learn.vue")
        },
        //其他页
        {
          path: "standard",
          name: "NmgLabourEducationStandard",
          component: () =>
            import("@/views/custom/Nmg_LabourEducation/standard.vue")
        },
      ]
    },
  ]
  // scrollBehavior(to, from, savedPosition) {
  //   if (savedPosition && to.meta.keepAlive) {
  //       return savedPosition;
  //   }
  //   return { x: 0, y: 0 };
  // },
});
// vue相同路由跳转报错问题处理
const originalPush = Router.prototype.push;
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export default router;